/**
 *
 * leave request Page
 *
 */
import Select from "react-select"
import React, { useEffect, useRef, useState } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
// import Modal from "react-bootstrap/Modal"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Input,
  Spinner,
  UncontrolledTooltip,
  Table,
} from "reactstrap"
import { withRouter, Link } from "react-router-dom"
import { connect } from "react-redux"
import Modal from "react-bootstrap/Modal"
// import Placeholder from "react-bootstrap/Placeholder"
import { useSelector, useDispatch } from "react-redux"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
// dispatch actions
import * as newUnassignedLeadAction from "../../store/bmV3VW5hc3NpZ25lZExlYWQ/actions"
// import * as customFieldAction from "../../store/y3VzdG9t/actions"
import { isEmpty } from "lodash"
import ButtonSpinner from "../../components/ButtonSpinner"
//date format
import moment from "moment"
import BootstrapTable from "react-bootstrap-table-next"
import { ToastContainer, toast } from "react-toastify"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
// import cellEditFactory from "react-bootstrap-table2-editor"
import SimpleReactValidator from "simple-react-validator"
import api from "helpers/Api"
import NewLeadCounter from "./newLeadCounter"
import "./styles.scss"
import PhoneInput from "react-phone-input-2"
import "react-phone-input-2/lib/style.css"

// import LeadHeader from "pages/Lead/component/LeadHeader"

const NewManageLead = (props) => {
  const { dispatch, searchBtnStyle } = props
  const title = "Unassigned Lead"

  const simpleValidator = useRef(new SimpleReactValidator())
  const simpleLeadValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()
  const [, forceUpdate1] = useState()
  const specificDispatch = useDispatch()

  const [downloadLoading, setDownloadLoading] = useState(false)
  // const [pageLoading, setPageLoading] = useState(false)

  useEffect(() => {
    dispatch(newUnassignedLeadAction.loadRecordsMetaData())

    dispatch(
      newUnassignedLeadAction.loadManageLead({
        page: 1,
        limit: 50,
        isManageLead: true,
        unAssign: true,
      })
    )
    // setPageLoading(true)
    // setTimeout(() => {
    //   setPageLoading(false)
    // }, 2000)
  }, [])

  const permissionUpdate = useSelector(
    (specificstate) => specificstate.newUnassignedLead
  )
  // const { records = [] } = useSelector(
  //   (specificstate) => specificstate.custom_field
  // )
  const {
    recordsMetaData = {},
    leadRecordsMetaData = {},
    lead_details = [],
    // custom_fields = [],
  } = permissionUpdate
  // console.log(permissionUpdate)
  // Date format
  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate
  const authUser = localStorage.getItem("authUser")

  const responseLogin = JSON.parse(authUser)
  // console.log(records, "records details")
  // console.log(lead_details, "lead_details")

  //Date format
  const dateSetting =
    !isEmpty(responseLogin) &&
    responseLogin.setting &&
    responseLogin.setting.dateFormate
      ? responseLogin.setting.dateFormate.toUpperCase()
      : !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  function addZeroBefore(number) {
    var numberString = "0" + number
    if (number < 10) {
      return numberString
    } else {
      return number
    }
  }
  //moment date
  var currentDate = moment().format("YYYY-MM-DD")
  var hourMoment = addZeroBefore(moment().format("HH"))
  var miniteMoment = addZeroBefore(moment().minutes())
  var dateTime = currentDate + "T" + hourMoment + ":" + miniteMoment

  console.log(dateTime, "date based output")
  // var currentTimeInputValue = currentHourMoment + ":" + currentMiniteMoment
  //Access section end

  const [btnLoader, setBtnLoader] = useState(false)

  //Modal state values
  const [clientConfirmModal, setClientConfirmModal] = useState(false)
  const [leadStatusModal, setLeadStatusModal] = useState(false)

  const [leadStatusCompany, setLeadStatusCompany] = useState([])
  const [leadStatusBranch, setLeadStatusBranch] = useState([])
  const [leadStatusEmployee, setLeadStatusEmployee] = useState([])
  const [leadStatusPriority, setLeadStatusPriority] = useState([])
  const [filterSalesUrge, setFilterSalesUrge] = useState([])
  const [source, setSource] = useState([])
  //Manage lead data
  const [followupData, setFollowupData] = useState({
    company: [],
    branch: [],
    _id: "",
    salesAgent: "",
    fromDate: "",
    leadNoStatus: "",
    leadId: "",
    toDate: "",
    leadFromDate: "",
    leadToDate: "",
    leadNo: "",
    mobileNo: "",
    followupDate: "",
  })
  //dropdown list
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [leadService, setLeadService] = useState([])
  const [event, setEvent] = useState([])
  const [leadStatus, setLeadStatus] = useState([])
  // const [salesAgent, setSalesAgent] = useState([])
  const [priority, setPriority] = useState([])
  const [editModal, setEditModal] = useState(false)
  const [deleteLeadModal, setDeleteLeadModal] = useState(false)

  //Add new lead data
  const [leadData, setLeadData] = useState({
    clientProfileRemarks: "",
    firstName: "",
    lastName: "",
    _id: "",
    leadDate: "",
    clientId: "",
    leadId: "",
    leadNo: "",
    salesAgent: "",
    leadType: "",
    eventId: "",
    clientLocation: "",
    primaryMobile: "",
    secondaryMobile: "",
    primaryMobileConfirm: false,
    secondaryMobileConfirm: false,
    whatsappNoConfirm: false,
    isRequiredNewClientEntry: false,
    primaryMobileValue: "",
    secondaryMobileValue: "",
    whatsAppNoValue: "",
    whatsappNo: "",
    address: "",
    remarks: "",
    activityId: "",
    insertedBy: "",
    insertedByName: "",
    pincode: "",
    emailId: "",
  })

  //dropdown list
  const [fileAttachment, setFileAttachment] = useState([])
  const [renderPage, setRenderPage] = useState(false)
  // const [isPrimaryChecked, setIsPrimaryChecked] = useState("")
  // const [isSecondaryChecked, setIsSecondaryChecked] = useState("")
  const [isSelfAssign, setIsSelfAssign] = useState([])
  const [leadCompany, setLeadCompany] = useState([])
  const [leadBranches, setLeadBranches] = useState([])
  const [leadServiceArray, setLeadServiceArray] = useState([])
  // const [leadEvent, setLeadEvent] = useState([])
  const [leadSource, setLeadSource] = useState([])
  const [leadSubSource, setLeadSubSource] = useState([])
  const [salesUrge, setSalesUrge] = useState([])
  const [clientProfile, setClientProfile] = useState([])
  const [city, setCity] = useState([])
  const [stateData, setStateData] = useState([])
  const [country, setCountry] = useState([])
  const [leadPriority, setLeadPriority] = useState([])
  const [uploadFileName, setUploadFileName] = useState("")
  const [message, setMessage] = useState("")

  const [mobileData, setMobileData] = useState({
    primaryMobileConfirm: false,
    secondaryMobileConfirm: false,
    whatsappNoConfirm: false,
    isRequiredNewClientEntry: false,
    primaryMobileValue: "",
    secondaryMobileValue: "",
    whatsAppNoValue: "",
  })

  //add new lead open
  const addNewLead = () => {
    setNewLeadModal(true)
    setFullscreen(true)
    setEditModal(false)
    dispatch(newUnassignedLeadAction.loadLeadRecordsMetaData())
    setLeadData({
      clientProfileRemarks: "",
      firstName: "",
      lastName: "",

      salesAgent: "",
      clientLocation: "",
      primaryMobile: "",
      secondaryMobile: "",
      primaryMobileConfirm: false,
      secondaryMobileConfirm: false,
      whatsappNoConfirm: false,
      isRequiredNewClientEntry: false,
      primaryMobileValue: "",
      secondaryMobileValue: "",
      whatsAppNoValue: "",
      whatsappNo: "",
      address: "",
      remarks: "",
      pincode: "",
      emailId: "",
    })
    setFileAttachment([])
    setIsSelfAssign([])
    setLeadCompany([])
    setLeadBranches([])
    setLeadServiceArray([])
    setLeadSource([])
    setLeadSubSource([])
    setSalesUrge([])
    setClientProfile([])
    setCity([])
    setStateData([])
    setCountry([])
    setLeadPriority([])
    setUploadFileName("")
  }

  // console.log(fileAttachment, "fileAttachment")
  // console.log(leadData, "leadData")
  console.log(uploadFileName, "uploadFileName")
  console.log(leadData, "leadData")
  //column checkbox modal

  const [columnModal, setColumnModal] = useState(false)

  //dropdown options api
  const branchOptions =
    !isEmpty(recordsMetaData) && recordsMetaData.branchOptions.length > 0
      ? recordsMetaData.branchOptions.filter(
          (branch) =>
            branch.companyId === companies.map((data) => data.value).toString()
        )
      : []

  const leadBranchOptions =
    !isEmpty(recordsMetaData) && recordsMetaData.branchOptions.length > 0
      ? recordsMetaData.branchOptions.filter(
          (branch) => branch.companyId === leadCompany.value
        )
      : []
  const subSourceOptions =
    !isEmpty(leadRecordsMetaData) &&
    leadRecordsMetaData.subSourceOptions.length > 0
      ? leadRecordsMetaData.subSourceOptions.filter(
          (source) => source.sourceId === leadSource.value
        )
      : []
  const stateOptions =
    !isEmpty(leadRecordsMetaData) && leadRecordsMetaData.stateOptions.length > 0
      ? leadRecordsMetaData.stateOptions.filter(
          (state) => state.countryId === country.value
        )
      : []
  const cityOptions =
    !isEmpty(leadRecordsMetaData) && leadRecordsMetaData.cityOptions.length > 0
      ? leadRecordsMetaData.cityOptions.filter(
          (city) => city.stateId === stateData.value
        )
      : []
  const serviceOptions =
    !isEmpty(recordsMetaData) && recordsMetaData.serviceOptions.length > 0
      ? recordsMetaData.serviceOptions.filter(
          (service) =>
            service.companyId.length > 0 &&
            service.companyId[0] ===
              companies.map((data) => data.value).toString()
        )
      : []
  const leadServiceOptions =
    !isEmpty(recordsMetaData) && recordsMetaData.serviceOptions.length > 0
      ? recordsMetaData.serviceOptions.filter(
          (service) =>
            service.companyId.length > 0 &&
            service.companyId[0] === leadCompany.value
        )
      : []
  const leadStatusBranchOptions =
    !isEmpty(recordsMetaData) && recordsMetaData.branchOptions
      ? recordsMetaData.branchOptions.filter(
          (branch) => branch.companyId === leadStatusCompany.value
        )
      : []

  //Company Table options
  // const companyTableOptions =
  //   leadCompany &&
  //   leadRecordsMetaData &&
  //   Object.keys(leadRecordsMetaData).length > 0 &&
  //   leadRecordsMetaData.companyTableOptions &&
  //   leadRecordsMetaData.companyTableOptions.length > 0
  //     ? leadRecordsMetaData.companyTableOptions.filter(
  //         (c) => c._id != leadCompany.value
  //       )
  //     : []

  const [crossPromotionData, setCrossPromotionData] = useState([
    {
      name: "",
      _id: "",
      yes: "",
      action: "",
      no: "",
    },
  ])

  const [crossPromotionLoad, setCrossPromotionLoad] = useState(false)

  const handleCrossPromotionChange = (e, index, name) => {
    let fieldsData = crossPromotionData

    if (name == "yes") {
      e = e.target.checked
      console.log(e, "e")
      fieldsData[index]["yes"] = e
      // fieldsData[index]["no"] = !e
      fieldsData[index]["action"] = e == true ? true : false

      setCrossPromotionData(fieldsData)
      setCrossPromotionLoad(!crossPromotionLoad)
    }
    // if (name == "no") {
    //   e = e.target.checked
    //   fieldsData[index]["no"] = checked
    //   // fieldsData[index]["yes"] = checked == true ? true : false
    //   fieldsData[index]["action"] = false
    //   setCrossPromotionData(fieldsData)
    //   setCrossPromotionLoad(!crossPromotionLoad)
    // }
  }

  //Custom Field Options
  const [customFieldData, setCustomFieldData] = useState([
    {
      _id: "",
      labelName: "",
      fieldName: "",
      defaultValue: "",
      helperText: "",
      datatype: "",
    },
  ])
  const [customFieldLoad, setCustomFieldLoad] = useState(false)

  // if (custom_fields && custom_fields.length > 0 && !customFieldLoad) {
  //   // const leadCustomFields = leadRecordsMetaData && leadRecordsMetaData.customFieldOptions.length > 0 ? leadRecordsMetaData.customFieldOptions.filter(customFields => customFields.value == leadServiceArray.value) : []

  //   const customFieldListArray =
  //     custom_fields.length > 0
  //       ? custom_fields.map((data) => {

  //             return {
  //               _id: data._id,
  //               labelName: data.labelName,
  //               defaultValue: data.defaultValue,
  //               helperText: data.helperText,
  //               datatype: data.datatype,
  //             }

  //         })
  //       : []

  //   console.log(customFieldListArray, "customFieldListArray")
  //   setCustomFieldData(customFieldListArray)
  //   setCustomFieldLoad(true)
  // }
  console.log(leadServiceArray, "leadServiceArray")

  const handleCustomFieldChange = (e, index, name) => {
    let customList = customFieldData

    if (e.target.name == "defaultValue") {
      e = e.target.value
      customList[index][name] = e
      setCustomFieldData(customList)
      setCustomFieldLoad(!customFieldLoad)
    }
  }

  console.log(customFieldData, "customFieldData")
  // console.log(crossPromotionData, "crossPromotionData")
  // console.log(companyTableOptions, "companyTableOptions")
  const employeeOptions =
    !isEmpty(recordsMetaData) && recordsMetaData.employeeOptions
  const fuseOptions = {
    keys: ["empCode", "label"],
  }
  const handleChange = (e) => {
    setFollowupData({ ...followupData, [e.target.name]: e.target.value })
    if (e.target.name == "mobileNo") {
      setFollowupData({
        ...followupData,
        mobileNo: e.target.value.replace(/\D/g, ""),
      })
    }
  }
  // const handleMobileChange = (e) => {
  //   setMobileData({ ...mobileData, [e.target.name]: e.target.value })

  // }
  console.log(mobileData, "mobileData")
  const handleLeadChange = (e) => {
    setLeadData({ ...leadData, [e.target.name]: e.target.value })
    if (e.target.name == "pincode") {
      setLeadData({
        ...leadData,
        pincode: e.target.value.replace(/\D/g, ""),
      })
    }
    if (e.target.name == "emailId") {
      const regEx = /[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}(.[a-z{2,8}])?/g
      if (regEx.test(e.target.value)) {
        setLeadData({
          ...leadData,
          emailId: e.target.value,
        })
        setMessage("")
      } else if (!regEx.test(e.target.value) && leadData.emailId != "") {
        setMessage("Enter the valid email")
      } else {
        setMessage("")
      }
    }
  }

  const fileAttachmentChange = async (e) => {
    if (e.target.files) {
      // console.log("qqqq", e.target.files)
      // await setMobileAttachmentSelected([])
      setFileAttachment(e.target.files)
      var file = e.target.files
      setUploadFileName(file[0].name)
      // setUploadFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = fileAttachment

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setFileAttachment(teamUploadValue)
            await setRenderPage(!renderPage)
          }
        })

        // await setAttachmentValidation(false)
        // await setMobileAttachmentForm(false)
      }
    }
  }

  //const currentdateTime = moment().format("YYYY-MM-DD LT")
  const [pageCount, setPageCount] = useState("")
  const [btnLoading, setBtnLoading] = useState(false)
  const [pageChange, setPageChange] = useState(false)
  const [newLeadModal, setNewLeadModal] = useState(false)
  const [fullscreen, setFullscreen] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  //Search value
  const [searchValueList, setSearchValueList] = useState({})
  console.log(searchValueList, "searchValueList")

  // const searchValue = !isEmpty(searchValueList)
  //   ? searchValueList
  //   : {
  //       page: 1,
  //       limit: 50,
  //     }

  //Apply filter
  const handleFilter = (e) => {
    e.preventDefault()
    var searchCompany =
      companies && companies.length > 0
        ? companies.map((data) => data.value)
        : ""
    var searchBranch = branches && branches ? branches.value : ""

    var searchSalesUrge =
      filterSalesUrge && filterSalesUrge ? filterSalesUrge.value : ""
    var searchSource = source && source ? source.value : ""

    // var searchsalesAgent = salesAgent && salesAgent ? salesAgent.value : ""

    var searchLeadFromDate =
      followupData && followupData.leadFromDate
        ? moment(followupData.leadFromDate).format("YYYY-MM-DD")
        : ""
    var searchLeadToDate =
      followupData && followupData.leadToDate
        ? moment(followupData.leadToDate).format("YYYY-MM-DD")
        : ""

    var searchLeadNo =
      followupData && followupData.leadNo ? followupData.leadNo : ""

    var searchleadService = leadService && leadService ? leadService.value : ""

    var searchvalue = {}
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = 50
    searchvalue.isManageLead = true
    searchvalue.unAssign = true
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchSalesUrge) {
      searchvalue.salesUrge = searchSalesUrge
    }
    if (searchSource) {
      searchvalue.leadSourceId = searchSource
    }
    // if (searchsalesAgent) {
    //   searchvalue.employeeId = searchsalesAgent
    // }
    if (searchLeadFromDate) {
      searchvalue.leadFromDate = searchLeadFromDate
    }
    if (searchLeadToDate) {
      searchvalue.leadToDate = searchLeadToDate
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchleadService) {
      searchvalue.leadServiceId = searchleadService
    }
    setSearchValueList(searchvalue)
    setPageLoad(!pageLoad)
    // console.log("searchCompany", searchvalue)
    specificDispatch(newUnassignedLeadAction.loadManageLead(searchvalue))
    setBtnLoader(true)
    setBtnLoading(true)
    setTimeout(() => {
      setBtnLoading(false)
      setBtnLoader(false)
    }, 2000)
  }
  const [resetManager, setResetManager] = useState(false)

  //reset functionalities
  const resetForm = () => {
    setCompanies([])
    setBranches([])
    setLeadStatus([])
    setEvent([])
    setResetManager(true)
    setTimeout(() => {
      setResetManager(false)
    }, 0)
    // setSalesAgent([])
    setLeadService([])
    setPriority([])
    setFollowupData({
      fromDate: "",
      leadFromDate: "",
      leadToDate: "",
      toDate: "",
      leadNo: "",
    })
    setFilterSalesUrge([])
    setSource([])
    setSearchValueList({})

    dispatch(
      newUnassignedLeadAction.loadManageLead({
        page: 1,
        limit: 50,
        isManageLead: true,
        unAssign: true,
      })
    )
  }

  console.log(leadStatusPriority, "leadStatusPriority")

  // let slNo = 0
  const manageNewLeadTable =
    !isEmpty(lead_details) && lead_details && lead_details.data.length > 0
      ? lead_details.data.map((data, index) => {
          // slNo = slNo + 1
          var leadDate = !isEmpty(data.leadDate)
            ? moment(data.leadDate)
                // .add(5, "hours")
                // .add(30, "minutes")
                .format(`${dateFormate} hh:mm A`)
            : []
          var eventDate =
            !isEmpty(data) && data.eventDate.length > 0
              ? data.eventDate
                  .map((date) => {
                    const eventDateDetails =
                      date != null ? moment(date).format(dateFormate) : ""
                    return eventDateDetails
                  })
                  .join(",")
              : ""
          var followupDate =
            !isEmpty(data) && data.followupDate.length > 0
              ? data.followupDate
                  .map((date) => moment(date).format(dateFormate))
                  .join(",")
              : ""
          const colorCode =
            !isEmpty(recordsMetaData) &&
            !isEmpty(data.processStatus.processStatusId) &&
            recordsMetaData.processStatusOptions &&
            recordsMetaData.processStatusOptions.length > 0
              ? recordsMetaData.processStatusOptions.find(
                  (_) => _.value == data.processStatus.processStatusId
                )
              : ""

          const agentDetails =
            data &&
            data.leadAssign.length > 0 &&
            recordsMetaData &&
            recordsMetaData.employeeOptions &&
            recordsMetaData.employeeOptions.length > 0
              ? recordsMetaData.employeeOptions.find(
                  (k) =>
                    k.value ==
                    data.leadAssign[
                      data.leadAssign.length - 1
                    ].assignedTo.toString()
                )
              : ""
          const createdBy =
            data &&
            data.insertedBy &&
            recordsMetaData &&
            recordsMetaData.employeeOptions &&
            recordsMetaData.employeeOptions.length > 0
              ? recordsMetaData.employeeOptions.find(
                  (k) => k.value == data.insertedBy
                )
              : ""

          return {
            _id: data._id,
            leadId: data.leadId,
            leadData: data,
            sNo: parseInt(data.seqNo + 1),
            leadNo: data.leadNo,
            activityId: data.activity,
            companyId: data.companyId ? data.companyId : "--",
            isSelfAssign: data.isSelfAssign ? data.isSelfAssign : "",
            eventId: data.eventId ? data.eventId : "",
            company: data.companyName ? data.companyName : "--",
            leadType: data.leadType ? data.leadType : "",
            branchId: data.branchId ? data.branchId : "--",
            emailId: data.emailId ? data.emailId : "",
            branch: data.branchName ? data.branchName : "",
            priorityStatusId: data.priorityStatusId
              ? data.priorityStatusId
              : "--",
            priorityStatusName: data.priorityStatusName
              ? data.priorityStatusName
              : "--",
            clientName: data.clientData
              ? data.clientData.firstName + " " + data.clientData.lastName
              : "",
            leadServiceId: data.leadServiceId ? data.leadServiceId : "",
            leadServiceName: data.leadServiceName ? data.leadServiceName : "",
            leadSourceName: data.leadSourceName ? data.leadSourceName : "--",
            leadSourceId: data.leadSourceId ? data.leadSourceId : "",
            leadSubSourceId: data.leadSubSourceId ? data.leadSubSourceId : "",
            crossPromotedList: data.crossPromotedList
              ? data.crossPromotedList
              : "",
            leadSubSourceName: data.leadSubSourceName
              ? data.leadSubSourceName
              : "",
            attachment: data.attachment ? data.attachment : "",
            address: data.primaryAddress ? data.primaryAddress : "",
            // remarks: data.remarks ? data.remarks : "--",
            clientProfileRemarks: data.clientProfileRemarks
              ? data.clientProfileRemarks
              : "",
            firstName: data.clientData ? data.clientData.firstName : "",
            lastName: data.clientData ? data.clientData.lastName : "",
            clientLocation: data.clientLocation ? data.clientLocation : "",
            countryName: !isEmpty(data.countryName) ? data.countryName : "",
            countryId: data.country ? data.country : "",
            stateName: !isEmpty(data.stateName) ? data.stateName : "",
            stateId: data.state ? data.state : "",
            cityName: !isEmpty(data.cityName) ? data.cityName : "",
            cityId: data.city ? data.city : "",
            pincode: data.pincode ? data.pincode : "",
            salesAgent: !isEmpty(agentDetails) ? agentDetails.name : "--",
            budget: data.budget,
            // isSelfAssign: data.isSelfAssign ? data.isSelfAssign : "",
            salesUrge: data.salesUrge ? data.salesUrge : "--",
            reassignAge: data.reassignAge ? data.reassignAge : "",
            leadAge: data.leadAge ? data.leadAge : "",
            aging:
              data.leadAge || data.reassignAge
                ? data.leadAge + " / " + data.reassignAge + " days"
                : "0/0 days",
            clientProfileId: data.clientProfile ? data.clientProfile._id : "",
            clientProfileName: data.clientProfileName
              ? data.clientProfileName
              : "",
            clientId: data.clientId ? data.clientId : "",
            primaryMobile: data.primaryMobile ? data.primaryMobile : "",
            secondaryMobile: data.secondaryMobile ? data.secondaryMobile : "-",
            whatsappNo: data.whatsAppNo ? data.whatsAppNo : "",

            colorCode: !isEmpty(colorCode) ? colorCode.colorCode : "",

            leadStatus: data.processStatus
              ? data.processStatus.processStatusName
              : "",
            processStatusName: data.processStatus
              ? data.processStatus.processStatusName
              : "",
            processStatus: data.processStatus
              ? data.processStatus.processStatusId
              : "",
            processStatusId: data.processStatus ? data.processStatus._id : "",
            eventName:
              data.eventName.length > 0
                ? data.eventName.map((events) => events).join(",")
                : "--",
            eventDate: !isEmpty(eventDate) ? eventDate : "--",
            followupDate: !isEmpty(followupDate) ? followupDate : "--",
            createdBy: createdBy ? createdBy.name : "--",
            createdById: data.insertedBy ? data.insertedBy : "",
            leadDate: data.leadDate ? leadDate : "--",
            followup: data.followup ? data.followup : "--",
            remarks: data.remarks ? data.remarks : "--",
            clientCode: data.clientCode ? data.clientCode : "--",

            // followUpRemarks: data.overAllStatus ? data.overAllStatus : "--",
            key: index,
          }
        })
      : []

  const leadStatusDetails = (data) => {
    setLeadStatusModal(true)
    setFollowupData({
      ...followupData,
      leadNoStatus: data.leadNo,
      leadId: data._id,
    })
    setLeadStatusCompany({
      label: data.company,
      value: data.companyId,
    })
    setLeadStatusBranch({
      label: data.branch,
      value: data.branchId,
    })
    setLeadStatusPriority({
      label: data.priorityStatusName,
      value: data.priorityStatusId,
    })
  }

  //pagination table data columns
  const initialColumns = [
    {
      dataField: "_id",
      text: "Id",
      hidden: true,
      sort: true,
      editable: false,
    },
    {
      dataField: "sNo",
      text: "S.No",
      hidden: false,
      editable: false,
    },
    {
      id: "3",
      dataField: "actions",
      text: "Action",
      hidden: false,
      csvExport: false,
      formatter: (cellContent, row) => {
        const processStatus = row && row.processStatusId
        const status = row && row.processStatusName
        return (
          <div className="d-flex flex-row">
            <button
              disabled={
                processStatus && processStatus === "PS1"
                  ? false
                  : processStatus === "PS10"
                  ? true
                  : false
              }
              type="button"
              onClick={() => editNewLeadDetails(row)}
              className="btn btn-success edit-table-btn"
            >
              <i className="mdi mdi-pencil d-block font-size-16"></i>
            </button>
            <button
              disabled={
                status && status === "Unassigned"
                  ? false
                  : processStatus === "PS10"
                  ? true
                  : true
              }
              type="button"
              onClick={() => {
                setFollowupData({
                  _id: row._id,
                })
                setDeleteLeadModal(true)
              }}
              className="btn btn-danger delete-table-btn mx-3"
            >
              <i className="mdi mdi-trash-can d-block font-size-16"></i>
            </button>
          </div>
        )
      },
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      hidden: false,
      sort: true,
      editable: false,
      formatter: (cellContent, row) => {
        return (
          <div className={row.processStatus === "PS1" ? "disabled-button" : ""}>
            <Link
              to={{
                pathname: `/client-details/${row._id}`,
                state: {
                  row: row.leadData,
                  leadClientId: row.leadData,
                  mode: "SALES",
                },
              }}
            >
              {row.leadNo}
              {row.processStatus === "PS1" ? (
                <>
                  <i
                    style={{ color: "grey" }}
                    id="quoteInfo"
                    aria-hidden="true"
                    className="fa fa-info-circle ms-1"
                  ></i>
                  <UncontrolledTooltip placement="right" target="quoteInfo">
                    This lead is not yet assigned. Please change the process
                    status, to enable the leadNo.
                  </UncontrolledTooltip>
                </>
              ) : (
                ""
              )}
            </Link>
          </div>
        )
      },
      // csvExport: false,
      style: {
        textTransform: "uppercase",
        color: "#e40d8c",
      },
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "leadType",
      text: "Lead Type",
      hidden: true,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "company",
      text: "Company",
      hidden: false,
      sort: true,
      editable: false,
      // formatter: (cellContent, row) => {
      //   return (
      //     <div>
      //       {pageLoading ? (
      //         <>
      //           {" "}
      //           <Placeholder animation="glow">
      //             <Placeholder xs={7} />
      //             <Placeholder xs={6} />{" "}
      //           </Placeholder>{" "}
      //         </>
      //       ) : (
      //         row.company
      //       )}
      //     </div>
      //   )
      // },
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "branch",
      text: "Branch",
      hidden: false,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "leadServiceName",
      text: "Service",
      hidden: true,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "140px",
      },
    },

    {
      dataField: "clientName",
      text: "Client Name",
      editable: false,
      hidden: false,
      sort: true,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "leadStatus",
      text: "Lead Status",
      editable: false,
      hidden: false,
      sort: true,
      formatter: (cellContent, row) => {
        return row.processStatusName ? (
          <div>
            <button
              style={{
                background: row.colorCode,
                border: "none",
                cursor: "pointer",
                color: "white",
                padding: "6px",
                borderRadius: "4px",
              }}
              onClick={() => {
                leadStatusDetails(row)
              }}
            >
              {row.processStatusName}
            </button>
          </div>
        ) : (
          "--"
        )
      },
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "salesUrge",
      text: "Sales Urge",
      hidden: false,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "150px",
      },
      style: {
        textTransform: "uppercase",
      },
    },
    {
      dataField: "clientProfileName",
      text: "Client Profile",
      hidden: false,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "clientProfileRemarks",
      text: "Client Profile Remarks",
      hidden: true,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "attachment",
      text: "Media Attachment",
      hidden: true,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "firstName",
      text: "First Name",
      hidden: true,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "lastName",
      text: "Last Name",
      hidden: true,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "clientLocation",
      text: "Client Location",
      hidden: true,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "countryName",
      text: "Country",
      hidden: true,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "stateName",
      text: "State",
      hidden: true,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "cityName",
      text: "City",
      hidden: true,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "primaryMobile",
      text: "Primary Number",
      hidden: false,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "secondaryMobile",
      text: "Secondary Number",
      hidden: true,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "whatsappNo",
      text: "Whatsapp No",
      hidden: true,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "priorityStatusName",
      text: "Priority Status",
      hidden: true,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "eventName",
      text: "Event Name",
      hidden: true,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "eventDate",
      text: "Event Date",
      hidden: true,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "followupDate",
      text: "Followup Date",
      hidden: true,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "aging",
      text: "Aging/Re-assigning",
      hidden: false,
      sort: true,
      editable: false,

      headerStyle: {
        minWidth: "185px",
      },
    },

    {
      dataField: "salesAgent",
      text: "Sales Agent",
      editable: false,
      hidden: true,
      sort: true,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "budget",
      text: "Budget",
      hidden: true,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "leadSourceName",
      text: "Source",
      hidden: false,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "leadSubSourceName",
      text: "Sub Source",
      hidden: true,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "createdBy",
      text: "Created By",
      hidden: false,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "isSelfAssign",
      text: "Is Self Assign",
      hidden: true,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "leadDate",
      text: "Lead Date",
      hidden: false,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "leadStatus",
      text: "Lead Status",
      hidden: false,
      sort: true,
      editable: false,
      formatter: (cellContent, row) => {
        return row.processStatusName ? (
          <div>
            <button
              style={{
                background: row.colorCode,
                border: "none",
                cursor: "pointer",
                color: "white",
                padding: "2px",
                borderRadius: "4px",
              }}
            >
              {row.processStatusName}
            </button>
          </div>
        ) : (
          "--"
        )
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
  ]

  // const [rendersPage, setRendersPage] = useState(false)
  // const handleMessage = () => {
  //   setRendersPage(!rendersPage)
  //   simpleValidator.current.hideMessages()
  // }
  const [columns, setColumns] = useState(initialColumns)

  const [oddColumnData, setOddColumnData] = useState([])
  const [evenColumnData, setEvenColumnData] = useState([])
  useEffect(() => {
    if (columns && columns.length > 0) {
      var array = columns
      var evenColumns = []
      var oddColumns = []

      for (var i = 0; i < array.length; i++) {
        if (i % 2 === 0) {
          oddColumns.push(array[i])
        } else {
          evenColumns.push(array[i])
        }
      }

      setOddColumnData(oddColumns)
      setEvenColumnData(evenColumns)
    }
  }, [columns])

  // console.log(oddColumnData, "oddcolumns")
  // console.log(evenColumnData, "evencolumns")

  const selectColumn = columns
    .filter((column) => column.hidden === false)
    .map((column) => column.dataField)

  const [selectedColumns, setSelectedColumns] = useState(selectColumn)

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target

    let updatedSelectedColumns
    if (checked) {
      updatedSelectedColumns = [...selectedColumns, value]
    } else {
      updatedSelectedColumns = selectedColumns.filter(
        (column) => column !== value
      )
    }

    setSelectedColumns(updatedSelectedColumns)
  }

  //  "Select All" checkbox
  const handleSelectAllChange = (e) => {
    const { checked } = e.target
    if (checked) {
      const allColumns = columns.map((column) => column.dataField)
      setSelectedColumns(allColumns)
    } else {
      const restoredColumns = initialColumns
        .filter((column) => !column.hidden)
        .map((column) => column.dataField)
      setSelectedColumns(restoredColumns)
    }
  }

  const handleSaveColumns = () => {
    setColumnModal(false)

    const updatedColumns = columns.map((column) => {
      const isColumnSelected = selectedColumns.includes(column.dataField)
      return { ...column, hidden: !isColumnSelected }
    })

    setColumns(updatedColumns)
    // default columns
    const defaultColumns = initialColumns.filter((column) => !column.hidden)
    const selectedNonDefaultColumns = selectedColumns.filter(
      (column) =>
        !defaultColumns.some(
          (defaultColumn) => defaultColumn.dataField === column
        )
    )

    if (selectedNonDefaultColumns.length > 0) {
      toast.success("New Columns added successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }
  }

  const handleRestoreToDefault = () => {
    const restoreColumns = initialColumns
      .filter((column) => !column.hidden)
      .map((column) => column.dataField)

    setSelectedColumns(restoreColumns)
  }

  const [loading, setLoading] = useState(false)

  //Search filter
  const [searchFilter, setSearchFilter] = useState(false)
  const handleClick = (e) => {
    // props.onSearch(input.value)
    // console.log(input.value, "inputs")
    e.preventDefault()
    setSearchFilter(true)
    dispatch(
      newUnassignedLeadAction.loadManageLead({
        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: 50,
        isManageLead: true,
        unAssign: true,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
    // console.log(input.value, "input")
  }

  //Pagination Component
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }
  // const [downloadData, setDownloadData] = useState("")

  // console.log(downloadData, "downloadData")

  const exportToCsv = () => {
    var searchCompany =
      companies && companies.length > 0
        ? companies.map((data) => data.value)
        : ""
    var searchBranch = branches && branches ? branches.value : ""

    var searchSalesUrge =
      filterSalesUrge && filterSalesUrge ? filterSalesUrge.value : ""
    var searchSource = source && source ? source.value : ""

    // var searchsalesAgent = salesAgent && salesAgent ? salesAgent.value : ""

    var searchLeadFromDate =
      followupData && followupData.leadFromDate
        ? moment(followupData.leadFromDate).format("YYYY-MM-DD")
        : ""
    var searchLeadToDate =
      followupData && followupData.leadToDate
        ? moment(followupData.leadToDate).format("YYYY-MM-DD")
        : ""

    var searchLeadNo =
      followupData && followupData.leadNo ? followupData.leadNo : ""

    var searchleadService = leadService && leadService ? leadService.value : ""

    var searchvalue = {}
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = 50
    searchvalue.isManageLead = true
    searchvalue.unAssign = true
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchSalesUrge) {
      searchvalue.salesUrge = searchSalesUrge
    }
    if (searchSource) {
      searchvalue.leadSourceId = searchSource
    }
    // if (searchsalesAgent) {
    //   searchvalue.employeeId = searchsalesAgent
    // }
    if (searchLeadFromDate) {
      searchvalue.leadFromDate = searchLeadFromDate
    }
    if (searchLeadToDate) {
      searchvalue.leadToDate = searchLeadToDate
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchleadService) {
      searchvalue.leadServiceId = searchleadService
    }
    setPageLoad(!pageLoad)
    // console.log("searchCompany", searchvalue)
    setDownloadLoading(true)
    api
      .post(`/get_all_manage_lead`, searchvalue)
      .then((response) => {
        const unassignedDataTable =
          !isEmpty(response.data.data) && response.data.data.data.length > 0
            ? response.data.data.data.map((data, index) => {
                var eventDateDetails =
                  !isEmpty(data) && data.eventDate.length > 0
                    ? data.eventDate
                        .map((date) => moment(date).format(dateFormate))
                        .join(",")
                    : ""
                const eventDate = !isEmpty(eventDateDetails)
                  ? JSON.stringify(eventDateDetails).replace(/","/g, "\n")
                  : ""
                var followupDateDetails =
                  !isEmpty(data) && data.followupDate.length > 0
                    ? data.followupDate
                        .map((date) => moment(date).format(dateFormate))
                        .join(",")
                    : ""
                const followupDate = !isEmpty(followupDateDetails)
                  ? JSON.stringify(followupDateDetails).replace(/","/g, "\n")
                  : ""
                var leadDate = !isEmpty(data.leadDate)
                  ? moment(data.leadDate)
                      // .add(5, "hours")
                      // .add(30, "minutes")
                      .format(`${dateFormate} hh:mm A`)
                  : []
                const eventNameDetails =
                  data.eventName.length > 0
                    ? data.eventName.map((events) => events).join(",")
                    : ""
                const eventName = !isEmpty(eventNameDetails)
                  ? JSON.stringify(eventNameDetails).replace(/","/g, "\n")
                  : ""
                const colorCode =
                  !isEmpty(recordsMetaData) &&
                  !isEmpty(data.processStatus.processStatusId) &&
                  recordsMetaData.processStatusOptions &&
                  recordsMetaData.processStatusOptions.length > 0
                    ? recordsMetaData.processStatusOptions.find(
                        (_) => _.value == data.processStatus.processStatusId
                      )
                    : ""

                const agentDetails =
                  data &&
                  data.leadAssign.length > 0 &&
                  recordsMetaData &&
                  recordsMetaData.employeeOptions &&
                  recordsMetaData.employeeOptions.length > 0
                    ? recordsMetaData.employeeOptions.find(
                        (k) =>
                          k.value ==
                          data.leadAssign[
                            data.leadAssign.length - 1
                          ].assignedTo.toString()
                      )
                    : ""
                const createdBy =
                  data &&
                  data.insertedBy &&
                  recordsMetaData &&
                  recordsMetaData.employeeOptions &&
                  recordsMetaData.employeeOptions.length > 0
                    ? recordsMetaData.employeeOptions.find(
                        (k) => k.value == data.insertedBy
                      )
                    : ""
                const countryName =
                  data &&
                  data.country &&
                  leadRecordsMetaData &&
                  leadRecordsMetaData.countryOptions &&
                  leadRecordsMetaData.countryOptions.length > 0
                    ? leadRecordsMetaData.countryOptions.find(
                        (k) => k.value == data.country
                      )
                    : ""
                const stateName =
                  data &&
                  data.state &&
                  leadRecordsMetaData &&
                  leadRecordsMetaData.stateOptions &&
                  leadRecordsMetaData.stateOptions.length > 0
                    ? leadRecordsMetaData.stateOptions.find(
                        (k) => k.value == data.state
                      )
                    : ""
                const cityName =
                  data &&
                  data.city &&
                  leadRecordsMetaData &&
                  leadRecordsMetaData.cityOptions &&
                  leadRecordsMetaData.cityOptions.length > 0
                    ? leadRecordsMetaData.cityOptions.find(
                        (k) => k.value == data.city
                      )
                    : ""
                // console.log(createdBy, "createdBy")

                return {
                  _id: data._id,
                  leadId: data.leadId,
                  leadData: data,
                  sNo: index + 1,
                  leadNo: data.leadNo,
                  companyId: data.companyId ? data.companyId : "--",
                  company: data.companyName ? data.companyName : "--",
                  leadType: data.leadType ? data.leadType : "--",
                  branchId: data.branchId ? data.branchId : "--",
                  emailId: data.emailId ? data.emailId : "",
                  branch: data.branchName ? data.branchName : "",
                  priorityStatusId: data.priorityStatusId
                    ? data.priorityStatusId
                    : "--",
                  priorityStatusName: data.priorityStatusName
                    ? data.priorityStatusName
                    : "--",
                  clientName: data.clientData
                    ? data.clientData.firstName + " " + data.clientData.lastName
                    : "",
                  leadService: data.leadServiceId ? data.leadServiceId : "",
                  leadServiceName: data.leadServiceName
                    ? data.leadServiceName
                    : "",
                  leadSourceName: data.leadSourceName
                    ? data.leadSourceName
                    : "--",
                  leadSourceId: data.leadSourceId ? data.leadSourceId : "",
                  leadSubSourceId: data.leadSubSourceId
                    ? data.leadSubSourceId
                    : "",
                  leadSubSourceName: data.leadSubSourceName
                    ? data.leadSubSourceName
                    : "",
                  attachment: data.attachment ? data.attachment : "",
                  address: data.primaryAddress ? data.primaryAddress : "",
                  // remarks: data.remarks ? data.remarks : "--",
                  clientProfileRemarks: data.clientProfileRemarks
                    ? data.clientProfileRemarks
                    : "",
                  firstName: data.clientData ? data.clientData.firstName : "",
                  lastName: data.clientData ? data.clientData.lastName : "",
                  clientLocation: data.clientLocation
                    ? data.clientLocation
                    : "",
                  countryName: !isEmpty(data.countryName)
                    ? data.countryName
                    : !isEmpty(countryName)
                    ? countryName.label
                    : "",
                  countryId: data.country ? data.country : "",
                  stateName: !isEmpty(data.stateName)
                    ? data.stateName
                    : !isEmpty(stateName)
                    ? stateName.label
                    : "",
                  stateId: data.state ? data.state : "",
                  cityName: !isEmpty(data.cityName)
                    ? data.cityName
                    : !isEmpty(cityName)
                    ? cityName.label
                    : "",
                  cityId: data.city ? data.city : "",
                  pincode: data.pincode ? data.pincode : "",
                  salesAgent: !isEmpty(agentDetails) ? agentDetails.name : "--",
                  budget: data.budget,
                  isSelfAssign: data.isSelfAssign ? data.isSelfAssign : "",
                  salesUrge: data.salesUrge ? data.salesUrge : "--",
                  reassignAge: data.reassignAge ? data.reassignAge : "",
                  leadAge: data.leadAge ? data.leadAge : "",
                  aging:
                    data.leadAge || data.reassignAge
                      ? data.leadAge + " / " + data.reassignAge + " days"
                      : "0/0 days",
                  clientProfileId: data.clientProfile
                    ? data.clientProfile._id
                    : "",
                  clientProfileName: data.clientProfileName
                    ? data.clientProfileName
                    : "",
                  clientId: data.clientId ? data.clientId : "--",
                  primaryMobile: data.primaryMobile ? data.primaryMobile : "--",
                  secondaryMobile: data.secondaryMobile
                    ? data.secondaryMobile
                    : "--",
                  whatsappNo: data.whatsAppNo ? data.whatsAppNo : "--",

                  colorCode: !isEmpty(colorCode) ? colorCode.colorCode : "",

                  leadStatus: data.processStatus
                    ? data.processStatus.processStatusName
                    : "",
                  processStatusName: data.processStatus
                    ? data.processStatus.processStatusName
                    : "",
                  processStatus: data.processStatus
                    ? data.processStatus.processStatusId
                    : "",
                  processStatusId: data.processStatus
                    ? data.processStatus._id
                    : "",
                  eventName: !isEmpty(eventName) ? eventName : "--",
                  eventDate: !isEmpty(eventDate) ? eventDate : "--",
                  followupDate: !isEmpty(followupDate) ? followupDate : "--",
                  createdBy: createdBy ? createdBy.name : "--",
                  leadDate: data.leadDate ? leadDate : "--",
                  followup: data.followup ? data.followup : "--",
                  remarks: data.remarks ? data.remarks : "--",
                  clientCode: data.clientCode ? data.clientCode : "--",

                  // followUpRemarks: data.overAllStatus ? data.overAllStatus : "--",
                  key: index,
                }
              })
            : []
        setTimeout(() => {
          let headerData = [
            "SNo,Lead No,Company Name, Branch Name,Client Name,Lead Status,Sales Urge, Client Profile,  Primary Mobile,Aging/Re-assigning,Created By,Lead Date",
            // Priority,
            // Event Name,
            // Event Date,
            // Followup Date,
          ]

          let usersCsv =
            !isEmpty(unassignedDataTable) &&
            unassignedDataTable.reduce((acc, user) => {
              const {
                sNo,
                leadNo,
                company,
                branch,
                clientName,
                processStatusName,
                salesUrge,
                clientProfile,
                primaryMobile,
                // priorityStatusName,
                // eventName,
                // eventDate,
                // followupDate,
                aging,
                // salesAgent,
                // budget,
                createdBy,
                leadDate,
              } = user
              acc.push([
                sNo,
                leadNo,
                company,
                branch,
                clientName,
                processStatusName,
                salesUrge,
                clientProfile,
                primaryMobile,
                // priorityStatusName,
                // eventName,
                // eventDate,
                // followupDate,
                aging,
                // salesAgent,
                // budget,
                createdBy,
                leadDate,
              ])

              // console.log("test", acc)
              return acc
            }, [])

          const userList =
            !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : ""
          // console.log(usersCsv, "usersCsv")
          downloadFile({
            data: [...headerData, ...userList].join("\n"),
            fileName: "UnassignedLead.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 1500)
        return response.data
      })
      .catch((error) => {
        Promise.reject(error)
        setDownloadLoading(false)
      })
    //   // specificDispatch(
    //   //   manageFollowupAction.loadManageFollowupExportList(searchvalue)
    //   // )
    // }
  }
  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4">
                        {/* <div className="d-flex flex-row ">
                          <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                            <div
                              className="position-relative mt-7"
                              style={searchBtnStyle || null}
                            >
                              <MySearch {...props.searchProps} />
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </div>{" "} */}
                      </Col>
                      {/* {downloadAccessId === "61bc3079e2e60e9919697604" ? ( */}
                      <Col
                        md="8"
                        style={{ marginBottom: "20px", marginTop: "-41px" }}
                      >
                        <div
                          style={{
                            float: "right",
                            width: "150px",
                          }}
                        >
                          <button
                            // className="btn btn-info"
                            style={{
                              background: "white",
                              color: "gray",
                              padding: "8px 18px",
                              borderRadius: "4px",
                              textAlign: "center",
                              border: "1px solid lightgray",
                            }}
                            onClick={() => setColumnModal(true)}
                          >
                            Select Column
                          </button>
                        </div>
                        <div
                          style={{
                            float: "right",
                            marginRight: "10px",
                          }}
                        >
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          // {...props.baseProps}
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          striped={true}
                          bordered={true}
                          noDataIndication={"No data found..."}
                          onTableChange={onTableChange}
                          // cellEdit={cellEditFactory({
                          //   mode: "click",
                          //   beforeSaveCell,
                          //   autoSelectText: true,
                          //   blurToSave: true,
                          // })}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone
                            // paginationTotalRenderer={leave_list.totalDataCount}
                            {...paginationProps}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const [pageLoad, setPageLoad] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: !isEmpty(lead_details) && lead_details.totalDataCount,
    data:
      !isEmpty(lead_details) && manageNewLeadTable.length > 0
        ? manageNewLeadTable.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (
    type,
    { page, sortField, sortOrder, currentIndex, sizePerPage }
  ) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    // console.log(page, "page")
    let result =
      !isEmpty(lead_details) && manageNewLeadTable.length > 0
        ? manageNewLeadTable
        : []
    if (
      !isEmpty(companies) ||
      !isEmpty(branches) ||
      !isEmpty(followupData.fromDate) ||
      !isEmpty(followupData.toDate) ||
      !isEmpty(event) ||
      !isEmpty(leadStatus) ||
      !isEmpty(priority) ||
      // !isEmpty(salesAgent) ||
      !isEmpty(leadService)
    ) {
      var searchCompany =
        companies && companies.length > 0
          ? companies.map((data) => data.value)
          : ""
      var searchBranch = branches && branches ? branches.value : ""

      var searchSalesUrge =
        filterSalesUrge && filterSalesUrge ? filterSalesUrge.value : ""
      var searchSource = source && source ? source.value : ""

      // var searchsalesAgent = salesAgent && salesAgent ? salesAgent.value : ""

      var searchLeadFromDate =
        followupData && followupData.leadFromDate
          ? moment(followupData.leadFromDate).format("YYYY-MM-DD")
          : ""
      var searchLeadToDate =
        followupData && followupData.leadToDate
          ? moment(followupData.leadToDate).format("YYYY-MM-DD")
          : ""

      var searchLeadNo =
        followupData && followupData.leadNo ? followupData.leadNo : ""

      var searchleadService =
        leadService && leadService ? leadService.value : ""

      var searchvalue = {}
      searchvalue.page = page
      searchvalue.limit = sizePerPage
      searchvalue.isManageLead = true
      searchvalue.unAssign = true
      if (searchCompany) {
        searchvalue.companyId = searchCompany
      }
      if (searchBranch) {
        searchvalue.branchId = searchBranch
      }
      if (searchSalesUrge) {
        searchvalue.salesUrge = searchSalesUrge
      }
      if (searchSource) {
        searchvalue.leadSourceId = searchSource
      }
      // if (searchsalesAgent) {
      //   searchvalue.employeeId = searchsalesAgent
      // }
      if (searchLeadFromDate) {
        searchvalue.leadFromDate = searchLeadFromDate
      }
      if (searchLeadToDate) {
        searchvalue.leadToDate = searchLeadToDate
      }
      if (searchLeadNo) {
        searchvalue.leadNo = searchLeadNo
      }
      if (searchleadService) {
        searchvalue.leadServiceId = searchleadService
      }
      setPageLoad(!pageLoad)
      // console.log("searchCompany", searchvalue)
      setLoading(true)
      specificDispatch(newUnassignedLeadAction.loadManageLead(searchvalue))
    } else {
      dispatch(
        newUnassignedLeadAction.loadManageLead({
          page: page,
          limit: sizePerPage,
          isManageLead: true,
          unAssign: true,
        })
      )
      setLoading(true)
      setPageLoad(!pageLoad)
    }
    setPageCount(page)
    setTimeout(() => {
      setLoading(false)
    }, 2000)
    if (sortOrder === "asc") {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return 1
        } else if (b[sortField] > a[sortField]) {
          return -1
        }
        return 0
      })
      setLoading(false)
    } else {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return -1
        } else if (b[sortField] > a[sortField]) {
          return 1
        }
        return 0
      })
      setLoading(false)
    }

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }

  //lead status assign

  const addLeadAssign = (e) => {
    e.preventDefault()
    if (simpleLeadValidator.current.allValid()) {
      const leadStatus = {
        _id: followupData.leadId,
        assignedTo: leadStatusEmployee.value,
        leadStatus: "PS2",
        companyId: leadStatusCompany.value,
        branchId: leadStatusBranch.value,
        priorityStatusId: leadStatusPriority.value,
      }

      dispatch(newUnassignedLeadAction.addLeadStatus(leadStatus))

      setTimeout(() => {
        dispatch(
          newUnassignedLeadAction.loadManageLead({
            isManageLead: true,
            unAssign: true,
            page: pageChange ? pageCount : 1,
            limit: 50,
          })
        )
        setLeadStatusModal(false)
        toast.success("Lead Assigned Successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
      })
    } else {
      simpleLeadValidator.current.showMessages()
      forceUpdate1(1)
      setLeadStatusModal(true)
    }
  }

  //Add lead
  const addNewLeadDetails = (e) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      // console.log("data")
      var today = new Date()
      const time =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1 < 10
          ? "0" + (today.getMonth() + 1)
          : today.getMonth() + 1) +
        "-" +
        (today.getDate() < 10 ? "0" + today.getDate() : today.getDate()) +
        " " +
        today.getHours() +
        ":" +
        (today.getMinutes() < 10
          ? "0" + today.getMinutes()
          : today.getMinutes()) +
        ":" +
        (today.getSeconds() < 10
          ? "0" + today.getSeconds()
          : today.getSeconds())
      // console.log(time, "time")
      const leadDetails = {
        companyId: leadCompany.value,
        branchId: leadBranches.value,
        leadServiceId: leadServiceArray.value,
        leadSourceId: leadSource.value,
        leadSubSourceId: leadSubSource.value,
        firstName: leadData.firstName,
        clientProfile: clientProfile.value,
        secondaryMobile: leadData.secondaryMobile,
        whatsAppNo: leadData.whatsappNo,
        priorityStatusId: leadPriority.value,
        salesUrge: salesUrge.value,
        primaryMobileConfirm: leadData.primaryMobileConfirm,
        // clientId: "638dfe726e4443505b4e992a",
        primaryMobile: leadData.primaryMobile,
        whatsAppNoConfirm: leadData.whatsappNoConfirm,
        primaryAddress: leadData.address,
        descriptions: leadData.remarks,
        crossPromotion:
          crossPromotionData.length > 0
            ? crossPromotionData.map((data) => {
                return {
                  companyId: data._id,
                  action: data.action == true ? true : false,
                }
              })
            : [],
        leadType: "wedding",
        eventId: "61f0149ed6a0f0d4716e2b9b",
        customField: [],
        processStatus: {
          id: "620be8a53f52687300b1f3fe",
          statusName: "open",
        },
        isRequiredNewClientEntry: true,
        leadNo: "",
        leadDate: time || "",
        clientDetails: {
          firstName: leadData.firstName,
          lastName: leadData.lastName,
          contact: {
            primaryMobile: {
              // code: data.primaryMobile && data.primaryMobile inputValue.data.dialCode,
              //code:  data.primaryMobile.substr(-10),
              // number:  data.primaryMobile,
              code:
                leadData.primaryMobile && leadData.primaryMobile.length === 10
                  ? "+" + leadData.primaryMobile.slice(0, -8)
                  : leadData.primaryMobile.length === 12
                  ? "+" + leadData.primaryMobile.slice(0, -10)
                  : leadData.primaryMobile.length === 11
                  ? "+" + leadData.primaryMobile.slice(0, -10)
                  : leadData.primaryMobile.length === 14
                  ? "+" + leadData.primaryMobile.slice(0, -12)
                  : leadData.primaryMobile.length === 15
                  ? "+" + leadData.primaryMobile.slice(0, -12)
                  : "",
              number:
                leadData.primaryMobile && leadData.primaryMobile.length === 12
                  ? leadData.primaryMobile.slice(2)
                  : leadData.primaryMobile.length === 11
                  ? leadData.primaryMobile.slice(1)
                  : leadData.primaryMobile.length === 10
                  ? leadData.primaryMobile.slice(2)
                  : leadData.primaryMobile.length === 14
                  ? leadData.primaryMobile.slice(2)
                  : leadData.primaryMobile.length === 15
                  ? leadData.primaryMobile.slice(3)
                  : "",
            },

            secondaryMobile: "" || {
              code:
                leadData.secondaryMobile &&
                leadData.secondaryMobile.length === 10
                  ? "+" + leadData.secondaryMobile.slice(0, -8)
                  : leadData.secondaryMobile.length === 12
                  ? "+" + leadData.secondaryMobile.slice(0, -10)
                  : leadData.secondaryMobile.length === 11
                  ? "+" + leadData.secondaryMobile.slice(0, -10)
                  : leadData.secondaryMobile.length === 14
                  ? "+" + leadData.secondaryMobile.slice(0, -12)
                  : leadData.secondaryMobile.length === 15
                  ? "+" + leadData.secondaryMobile.slice(0, -12)
                  : "",
              //code :leadData.secondaryMobile&& leadData.secondaryMobile.length > 10 ? leadData.secondaryMobile.slice(0,-11):leadData.secondaryMobile.slice(0,-10),
              //code: "" || leadData.secondaryMobile !== "undefined" ? leadData.secondaryMobile.slice(0,-10) : "",
              number:
                leadData.secondaryMobile &&
                leadData.secondaryMobile.length === 12
                  ? leadData.secondaryMobile.slice(2)
                  : leadData.secondaryMobile.length === 11
                  ? leadData.secondaryMobile.slice(1)
                  : leadData.secondaryMobile.length === 10
                  ? leadData.secondaryMobile.slice(2)
                  : leadData.secondaryMobile.length === 14
                  ? leadData.secondaryMobile.slice(2)
                  : leadData.secondaryMobile.length === 15
                  ? leadData.secondaryMobile.slice(3)
                  : "",
            },
            whatsAppNo: {
              code:
                leadData.whatsappNo && leadData.whatsappNo.length === 10
                  ? "+" + leadData.whatsappNo.slice(0, -8)
                  : leadData.whatsappNo.length === 12
                  ? "+" + leadData.whatsappNo.slice(0, -10)
                  : leadData.whatsappNo.length === 11
                  ? "+" + leadData.whatsappNo.slice(0, -10)
                  : leadData.whatsappNo.length === 14
                  ? "+" + leadData.whatsappNo.slice(0, -12)
                  : leadData.whatsappNo.length === 15
                  ? "+" + leadData.whatsappNo.slice(0, -12)
                  : "",
              number:
                leadData.whatsappNo && leadData.whatsappNo.length === 12
                  ? leadData.whatsappNo.slice(2)
                  : leadData.whatsappNo.length === 11
                  ? leadData.whatsappNo.slice(1)
                  : leadData.whatsappNo.length === 10
                  ? leadData.whatsappNo.slice(2)
                  : leadData.whatsappNo.length === 14
                  ? leadData.whatsappNo.slice(2)
                  : leadData.whatsappNo.length === 15
                  ? leadData.whatsappNo.slice(3)
                  : "",
            },
          },
          clientLocation: leadData.clientLocation,
          emailId: leadData.emailId,
          address: {
            primary: leadData.address,
            secondary: leadData.address || "",
          },
          pincode: leadData.pincode,
          city: "" || city.value,
          state: "" || stateData.value,
          country: "" || country.value,
        },
        clientProfileRemarks: leadData.clientProfileRemarks,
        isSelfAssign: isSelfAssign == true ? true : false,
        attachment: fileAttachment.length > 0 ? fileAttachment[0].name : "",
      }
      console.log(leadDetails, "leadDetails")
      if (
        !isEmpty(leadData.primaryMobileValue) ||
        !isEmpty(
          leadData.secondaryMobileValue || !isEmpty(leadData.whatsAppNoValue)
        )
      ) {
        setClientConfirmModal(true)
      } else {
        dispatch(newUnassignedLeadAction.addManageLead(leadDetails))
        setClientConfirmModal(false)
        setBtnLoader(true)
        setTimeout(() => {
          setBtnLoader(false)
          setNewLeadModal(false)
          dispatch(
            newUnassignedLeadAction.loadManageLead({
              isManageLead: true,
              unAssign: true,
              page: pageChange ? pageCount : 1,
              limit: 50,
            })
          )
          toast.success("Records Added Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          })
        }, 2000)
      }
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
      setNewLeadModal(true)
    }
  }

  console.log(message, "message")
  const editNewLeadDetails = (data) => {
    const primaryMobileNo = !isEmpty(data.primaryMobile)
      ? data.primaryMobile.slice(1)
      : ""
    console.log(primaryMobileNo, "primaryMobileNo")
    const secondaryMobileNo = !isEmpty(data.secondaryMobile)
      ? data.secondaryMobile.slice(1)
      : ""
    console.log(secondaryMobileNo, "secondaryMobileNo")
    const whatsappNo = !isEmpty(data.whatsappNo) ? data.whatsappNo.slice(1) : ""
    console.log(whatsappNo, "whatsappNo")
    dispatch(newUnassignedLeadAction.loadLeadRecordsMetaData())
    // console.log(data, "data")
    setEditModal(true)
    setNewLeadModal(true)
    setFullscreen(true)
    setLeadData({
      clientProfileRemarks: data.clientProfileRemarks,
      firstName: data.firstName,
      lastName: data.lastName,
      leadDate: data.leadDate,
      clientId: data.clientId,
      leadType: data.leadType,
      leadNo: data.leadNo,
      eventId: data.eventId,
      activityId: data.activityId,
      insertedBy: data.createdById,
      insertedByName: data.createdBy,
      salesAgent: "",
      clientLocation: data.clientLocation,
      primaryMobile: primaryMobileNo,
      secondaryMobile: secondaryMobileNo,
      primaryMobileConfirm: false,
      secondaryMobileConfirm: false,
      whatsappNoConfirm: false,
      isRequiredNewClientEntry: false,
      primaryMobileValue: "",
      secondaryMobileValue: "",
      whatsAppNoValue: "",
      whatsappNo: whatsappNo,
      address: data.address,
      remarks: data.remarks,
      pincode: data.pincode,
      emailId: data.emailId,
      _id: data._id,
    })
    setCrossPromotionData(data.crossPromotedList)

    setIsSelfAssign(data.isSelfAssign)
    setSalesUrge({
      label: data.salesUrge,
      value: data.salesUrge,
    })
    setTimeout(() => {
      if (isEmpty(data.countryName)) {
        const countryName =
          data.countryName &&
          leadRecordsMetaData &&
          leadRecordsMetaData.countryOptions.length > 0
            ? leadRecordsMetaData.countryOptions.find(
                (k) => k.value == data.countryId
              )
            : ""

        setCountry({
          label: countryName.label,
          value: data.countryId,
        })
      } else {
        setCountry({
          label: data.countryName,
          value: data.countryId,
        })
      }

      if (isEmpty(data.stateName)) {
        const stateName =
          data.state &&
          leadRecordsMetaData &&
          leadRecordsMetaData.stateOptions.length > 0
            ? leadRecordsMetaData.stateOptions.find(
                (k) => k.value == data.stateId
              )
            : ""
        setStateData({
          label: stateName.label,
          value: data.stateId,
        })
      } else {
        setStateData({
          label: data.stateName,
          value: data.stateId,
        })
      }

      if (isEmpty(data.cityName)) {
        const cityName =
          data.city &&
          leadRecordsMetaData &&
          leadRecordsMetaData.cityOptions.length > 0
            ? leadRecordsMetaData.cityOptions.find(
                (k) => k.value == data.cityId
              )
            : ""
        console.log(cityName, "cityName")
        setCity({
          label: cityName.label,
          value: data.cityId,
        })
      } else {
        setCity({
          label: data.cityName,
          value: data.cityId,
        })
      }
      if (isEmpty(data.clientProfileName)) {
        const clientProfileName =
          data.clientProfileId &&
          leadRecordsMetaData &&
          leadRecordsMetaData.clientProfileOptions &&
          leadRecordsMetaData.clientProfileOptions.length > 0
            ? leadRecordsMetaData.clientProfileOptions.find(
                (k) => k.value == data.clientProfileId
              )
            : ""
        console.log(clientProfileName, "clientProfileName")
        setClientProfile({
          label: clientProfileName.label,
          value: data.clientProfileId,
        })
      } else {
        setClientProfile({
          value: data.clientProfileId,
          label: data.clientProfileName,
        })
      }
    }, 1500)
    setLeadPriority({
      label: data.priorityStatusName,
      value: data.priorityStatusId,
    })
    setLeadCompany({
      label: data.company,
      value: data.companyId,
    })
    setLeadBranches({
      label: data.branch,
      value: data.branchId,
    })
    setUploadFileName(data.attachment)
    setLeadServiceArray({
      label: data.leadServiceName,
      value: data.leadServiceId,
    })
    setLeadSource({
      value: data.leadSourceId,
      label: data.leadSourceName,
    })
    const leadSubSource = !isEmpty(data.leadSubSourceName)
      ? {
          label: data.leadSubSourceName,
          value: data.leadSubSourceId,
        }
      : []
    setLeadSubSource(leadSubSource)
  }

  const updateNewLeadDetails = (e) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      // console.log("data")

      const leadDetails = {
        _id: leadData._id,
        companyId: leadCompany.value,
        branchId: leadBranches.value,
        leadServiceId: leadServiceArray.value,
        leadSourceId: leadSource.value,
        leadSubSourceId: leadSubSource.value,
        firstName: leadData.firstName,
        clientProfile: clientProfile.value,
        secondaryMobile: leadData.secondaryMobile,
        whatsAppNo: leadData.whatsappNo,
        priorityStatusId: leadPriority.value,
        salesUrge: salesUrge.value,
        primaryMobileConfirm: leadData.primaryMobileConfirm,
        clientId: leadData.clientId,
        primaryMobile: leadData.primaryMobile,
        whatsAppNoConfirm: leadData.whatsappNoConfirm,
        primaryAddress: leadData.address,
        descriptions: leadData.remarks,
        crossPromotion:
          crossPromotionData.length > 0
            ? crossPromotionData.map((data) => {
                return {
                  companyId: data._id,
                  action: !isEmpty(data.action) ? true : false,
                }
              })
            : [],
        leadType: leadData.leadType,
        eventId: leadData.eventId,
        customField: [],
        // processStatus: {
        //   id: "620be8a53f52687300b1f3fe",
        //   statusName: "open",
        // },
        isRequiredNewClientEntry: true,
        leadNo: leadData.leadNo,
        // leadDate: leadData.leadDate,
        activity: {
          _id: leadData.activityId,
        },
        insertedBy: {
          _id: leadData.insertedBy,
          name: leadData.insertedByName,
        },
        clientDetails: {
          firstName: leadData.firstName,
          lastName: leadData.lastName,
          contact: {
            primaryMobile: {
              // code: data.primaryMobile && data.primaryMobile inputValue.data.dialCode,
              //code:  data.primaryMobile.substr(-10),
              // number:  data.primaryMobile,
              code:
                leadData.primaryMobile && leadData.primaryMobile.length === 10
                  ? "+" + leadData.primaryMobile.slice(0, -8)
                  : leadData.primaryMobile.length === 12
                  ? "+" + leadData.primaryMobile.slice(0, -10)
                  : leadData.primaryMobile.length === 11
                  ? "+" + leadData.primaryMobile.slice(0, -10)
                  : leadData.primaryMobile.length === 14
                  ? "+" + leadData.primaryMobile.slice(0, -12)
                  : leadData.primaryMobile.length === 15
                  ? "+" + leadData.primaryMobile.slice(0, -12)
                  : "",
              number:
                leadData.primaryMobile && leadData.primaryMobile.length === 12
                  ? leadData.primaryMobile.slice(2)
                  : leadData.primaryMobile.length === 11
                  ? leadData.primaryMobile.slice(1)
                  : leadData.primaryMobile.length === 10
                  ? leadData.primaryMobile.slice(2)
                  : leadData.primaryMobile.length === 14
                  ? leadData.primaryMobile.slice(2)
                  : leadData.primaryMobile.length === 15
                  ? leadData.primaryMobile.slice(3)
                  : "",
            },

            secondaryMobile: "" || {
              code:
                leadData.secondaryMobile &&
                leadData.secondaryMobile.length === 10
                  ? "+" + leadData.secondaryMobile.slice(0, -8)
                  : leadData.secondaryMobile.length === 12
                  ? "+" + leadData.secondaryMobile.slice(0, -10)
                  : leadData.secondaryMobile.length === 11
                  ? "+" + leadData.secondaryMobile.slice(0, -10)
                  : leadData.secondaryMobile.length === 14
                  ? "+" + leadData.secondaryMobile.slice(0, -12)
                  : leadData.secondaryMobile.length === 15
                  ? "+" + leadData.secondaryMobile.slice(0, -12)
                  : "",
              //code :leadData.secondaryMobile&& leadData.secondaryMobile.length > 10 ? leadData.secondaryMobile.slice(0,-11):leadData.secondaryMobile.slice(0,-10),
              //code: "" || leadData.secondaryMobile !== "undefined" ? leadData.secondaryMobile.slice(0,-10) : "",
              number:
                leadData.secondaryMobile &&
                leadData.secondaryMobile.length === 12
                  ? leadData.secondaryMobile.slice(2)
                  : leadData.secondaryMobile.length === 11
                  ? leadData.secondaryMobile.slice(1)
                  : leadData.secondaryMobile.length === 10
                  ? leadData.secondaryMobile.slice(2)
                  : leadData.secondaryMobile.length === 14
                  ? leadData.secondaryMobile.slice(2)
                  : leadData.secondaryMobile.length === 15
                  ? leadData.secondaryMobile.slice(3)
                  : "",
            },
            whatsAppNo: {
              code:
                leadData.whatsappNo && leadData.whatsappNo.length === 10
                  ? "+" + leadData.whatsappNo.slice(0, -8)
                  : leadData.whatsappNo.length === 12
                  ? "+" + leadData.whatsappNo.slice(0, -10)
                  : leadData.whatsappNo.length === 11
                  ? "+" + leadData.whatsappNo.slice(0, -10)
                  : leadData.whatsappNo.length === 14
                  ? "+" + leadData.whatsappNo.slice(0, -12)
                  : leadData.whatsappNo.length === 15
                  ? "+" + leadData.whatsappNo.slice(0, -12)
                  : "",
              number:
                leadData.whatsappNo && leadData.whatsappNo.length === 12
                  ? leadData.whatsappNo.slice(2)
                  : leadData.whatsappNo.length === 11
                  ? leadData.whatsappNo.slice(1)
                  : leadData.whatsappNo.length === 10
                  ? leadData.whatsappNo.slice(2)
                  : leadData.whatsappNo.length === 14
                  ? leadData.whatsappNo.slice(2)
                  : leadData.whatsappNo.length === 15
                  ? leadData.whatsappNo.slice(3)
                  : "",
            },
          },
          clientLocation: leadData.clientLocation,
          emailId: leadData.emailId,
          address: {
            primary: leadData.address,
            secondary: leadData.address || "",
          },
          pincode: leadData.pincode,
          city: "" || city.value,
          state: "" || stateData.value,
          country: "" || country.value,
        },
        clientProfileRemarks: leadData.clientProfileRemarks,
        isSelfAssign: isSelfAssign == true ? true : false,
        attachment: fileAttachment.length > 0 ? fileAttachment[0].name : "",
      }
      console.log(leadDetails, "leadDetails")
      if (
        !isEmpty(leadData.primaryMobileValue) &&
        !isEmpty(
          leadData.secondaryMobileValue && !isEmpty(leadData.whatsAppNoValue)
        )
      ) {
        setClientConfirmModal(true)
      } else {
        dispatch(newUnassignedLeadAction.updateManageLead(leadDetails))
        setClientConfirmModal(false)
        setBtnLoader(true)
        setTimeout(() => {
          setBtnLoader(false)
          setNewLeadModal(false)
          dispatch(
            newUnassignedLeadAction.loadManageLead({
              isManageLead: true,
              unAssign: true,
              page: pageChange ? pageCount : 1,
              limit: 50,
            })
          )
          toast.success("Records Updated Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          })
        }, 2000)
      }
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
      setNewLeadModal(true)
    }
  }

  // console.log(isSelfAssign, "isSelfAssign")

  const deleteNewLead = () => {
    const leadDetails = {
      leadId: [followupData._id],
      status: 3,
    }
    dispatch(newUnassignedLeadAction.deleteManageLead(leadDetails))
    setTimeout(() => {
      dispatch(
        newUnassignedLeadAction.loadManageLead({
          isManageLead: true,
          unAssign: true,
          page: pageChange ? pageCount : 1,
          limit: 50,
        })
      )
      toast.error("Records Delete Successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
      setDeleteLeadModal(false)
    }, 1000)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"Sales"} breadcrumbItem={title} />
          <Row className="">
            <Col lg="12" md="12" sm="12" xs="12" className="mb-3">
              <Button
                // className="btn btn-secondary"
                style={{
                  backgroundColor: "#e40d8c",
                  color: "white",
                  border: "none",
                  float: "right",
                }}
                onClick={() => {
                  addNewLead()
                }}
              >
                Add New Lead
              </Button>
            </Col>
          </Row>
          <Row>
            <NewLeadCounter />
          </Row>
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="company"
                          value={companies}
                          onChange={(e) => {
                            setCompanies(e)

                            setBranches([])
                            setLeadService([])
                          }}
                          options={
                            recordsMetaData
                              ? recordsMetaData.companyOptions
                              : []
                          }
                          isMulti
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branch"
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                          style={{
                            zIndex: 20,
                          }}
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Sales Urge"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="filterSalesUrge"
                          value={filterSalesUrge}
                          onChange={(e) => setFilterSalesUrge(e)}
                          options={[
                            { label: "Hot", value: "hot" },
                            { label: "Warm", value: "warm" },
                            { label: "Cold", value: "cold" },
                          ]}
                          placeholder="Select Sales Urge"
                          classNamePrefix="select2-selection"
                        />
                      </Col>

                      {/* <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Sales Agent"}
                          </Label>
                        </div>
                        <ReactSearchAutocomplete
                          name="salesAgent"
                          key={resetManager}
                          items={employeeOptions}
                          value={salesAgent ? salesAgent : ""}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setSalesAgent(e)}
                          onChange={(e) => setSalesAgent(e.target.value)}
                          placeholder="Enter Sales Agent"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col> */}
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Lead Service"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="leadService"
                          value={leadService}
                          onChange={(e) => setLeadService(e)}
                          options={serviceOptions}
                          placeholder="Select Lead Service"
                          classNamePrefix="select2-selection"
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Source"} </Label>
                        </div>
                        <Select
                          type="text"
                          name="source"
                          value={source}
                          onChange={(e) => setSource(e)}
                          options={
                            recordsMetaData.sourceOptions
                              ? recordsMetaData.sourceOptions
                              : []
                          }
                          placeholder="Select Source"
                          classNamePrefix="select2-selection"
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Lead No"}
                          </Label>
                        </div>
                        <Input
                          type="text"
                          placeholder="Enter Lead No"
                          name="leadNo"
                          value={followupData.leadNo}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Lead From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="leadFromDate"
                          max={followupData.leadToDate}
                          value={followupData.leadFromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"To Date"}>
                            {"Lead To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="leadToDate"
                          min={followupData.leadFromDate}
                          value={followupData.leadToDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-4">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            onClick={(e) => handleFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/*Table start*/}
          <Row
            style={{
              zIndex: 5,
            }}
          >
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <div
                    className="d-flex flex-row"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                      <form onSubmit={handleClick} className="d-flex flex-row">
                        <div style={searchBtnStyle || null}>
                          <Input
                            type="text"
                            name="searchInput"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="form-control"
                            placeholder="Search"
                            style={{ position: "relative" }}
                          />
                          <i
                            className="bx bx-search-alt"
                            style={{
                              position: "absolute",
                              top: "54px",
                              left: "41px",
                              fontSize: "13px",
                            }}
                          />
                        </div>
                        <button
                          className="btn btn-success mx-2"
                          type="submit"
                          style={{
                            background: searchFilter ? "#2ca67a" : "",
                            color: searchFilter ? "#ffffff" : "",
                          }}
                          // onClick={(e) => handleClick()}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>{" "}
                  <RemotePagination
                    data={manageNewLeadTable}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={
                      !isEmpty(lead_details) ? lead_details.totalDataCount : 0
                    }
                    onTableChange={handleTableChange}
                  />
                  {loading ? (
                    <Modal
                      show={loading}
                      style={{ width: "7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                        {/* <span>Loading...</span> */}
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                  {btnLoading ? (
                    <Modal
                      show={btnLoading}
                      style={{ width: "7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                        {/* <span>Loading...</span> */}
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                  {downloadLoading ? (
                    <Modal
                      show={downloadLoading}
                      style={{ width: "7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                        {/* <span>Loading...</span> */}
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                  {columnModal && (
                    <Modal size="xl" show={columnModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Edit Columns
                        <span>
                          <i
                            className="fa fa-times quote-close"
                            aria-hidden="true"
                            onClick={() => setColumnModal(false)}
                          ></i>
                        </span>
                      </Modal.Header>
                      <Modal.Body>
                        <Row>
                          <div>
                            <Input
                              type="checkbox"
                              checked={
                                selectedColumns.length === columns.length
                              }
                              onChange={(e) => handleSelectAllChange(e)}
                              style={{ width: "15px", height: "15px" }}
                            />
                            <Label
                              style={{ fontSize: "16px", marginLeft: "10px" }}
                            >
                              Select All
                            </Label>
                          </div>
                        </Row>
                        <Row>
                          <Col sm="12" md="6" lg="6" className="ml-4">
                            {oddColumnData.map((column) => (
                              <div
                                key={column.dataField}
                                className="d-flex flex-row"
                              >
                                <div className="form-check form-check-inline">
                                  <Input
                                    type="checkbox"
                                    value={column.dataField}
                                    checked={selectedColumns.includes(
                                      column.dataField
                                    )}
                                    onChange={(e) => handleCheckboxChange(e)}
                                    style={{ width: "15px", height: "15px" }}
                                  />
                                  <Label
                                    style={{
                                      fontSize: "16px",
                                      marginLeft: "10px",
                                    }}
                                  >
                                    {column.text}
                                  </Label>
                                </div>
                              </div>
                            ))}
                          </Col>
                          <Col sm="12" md="6" lg="6">
                            {evenColumnData.map((column) => (
                              <div
                                key={column.dataField}
                                className="d-flex flex-row"
                              >
                                <div className="form-check form-check-inline">
                                  <Input
                                    type="checkbox"
                                    value={column.dataField}
                                    checked={selectedColumns.includes(
                                      column.dataField
                                    )}
                                    onChange={(e) => handleCheckboxChange(e)}
                                    style={{ width: "15px", height: "15px" }}
                                  />
                                  <Label
                                    style={{
                                      fontSize: "16px",
                                      marginLeft: "10px",
                                    }}
                                  >
                                    {column.text}
                                  </Label>
                                </div>
                              </div>
                            ))}
                          </Col>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <p
                          className="text-decoration-underline text-info"
                          style={{ cursor: "pointer", fontSize: "16px" }}
                          onClick={handleRestoreToDefault}
                        >
                          Restore To Default
                        </p>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setColumnModal(false)
                            setSelectedColumns(selectColumn)
                          }}
                        >
                          Close
                        </Button>
                        <Button
                          variant="primary"
                          className="btn btn-success"
                          onClick={() => handleSaveColumns()}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {newLeadModal && (
                    <Modal fullscreen={fullscreen} show={newLeadModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "white",
                          // color: "black",
                          fontSize: "16px",
                          fontWeight: "600",
                          textTransform: "uppercase",

                          boxShadow: "#efecec 3px 3px 12px -3px",
                        }}
                      >
                        Add New Lead
                        <span>
                          <i
                            className="fa fa-times quote-close"
                            aria-hidden="true"
                            onClick={() => setNewLeadModal(false)}
                          ></i>
                        </span>
                      </Modal.Header>
                      <Modal.Body
                        style={{
                          padding: "10px 24px",
                        }}
                      >
                        <Row className="lead-cards">
                          <Col lg="4" md="4" sm="12" xs="12">
                            <div className="d-flex justify-content-between">
                              <Label
                                className={"form-label"}
                                htmlFor={"Company"}
                              >
                                {"Company"}{" "}
                                <span
                                  style={{
                                    color: "red",
                                    marginLeft: "4px",
                                  }}
                                >
                                  *
                                </span>
                              </Label>
                            </div>

                            <Select
                              type="text"
                              name="leadCompany"
                              value={leadCompany}
                              onChange={(e) => {
                                setLeadCompany(e)
                                setLeadBranches([])
                                setLeadServiceArray([])
                                if (e) {
                                  const companyTableOptions =
                                    leadCompany &&
                                    leadRecordsMetaData &&
                                    Object.keys(leadRecordsMetaData).length >
                                      0 &&
                                    leadRecordsMetaData.companyTableOptions &&
                                    leadRecordsMetaData.companyTableOptions
                                      .length > 0
                                      ? leadRecordsMetaData.companyTableOptions.filter(
                                          (c) => c._id != e.value
                                        )
                                      : []
                                  const crossPromotionList =
                                    companyTableOptions.length > 0
                                      ? companyTableOptions.map((data) => {
                                          return {
                                            name: data.name,
                                            _id: data._id,
                                            yes: false,
                                            no: false,
                                            action: "",
                                          }
                                        })
                                      : []
                                  setCrossPromotionData(crossPromotionList)
                                }
                              }}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.companyOptions
                                  : []
                              }
                              // isMulti
                              placeholder="Select Company"
                              classNamePrefix="select2-selection"
                            />
                            {simpleValidator.current.message(
                              "Company",
                              leadCompany,
                              "required"
                            )}
                          </Col>
                          <Col lg="4" md="4" sm="12" xs="12">
                            <div className="d-flex justify-content-between">
                              <Label
                                className={"form-label"}
                                htmlFor={"Branch"}
                              >
                                {"Branch"}{" "}
                                <span
                                  style={{
                                    color: "red",
                                    marginLeft: "4px",
                                  }}
                                >
                                  *
                                </span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="branches"
                              value={leadBranches}
                              onChange={(e) => setLeadBranches(e)}
                              options={leadBranchOptions}
                              className={
                                !isEmpty(leadCompany) ? "" : "disabled-button"
                              }
                              placeholder="Select Branch"
                              classNamePrefix="select2-selection"
                            />
                            {simpleValidator.current.message(
                              "Branches",
                              leadBranches.value,
                              "required"
                            )}
                          </Col>
                          <Col lg="4" md="4" sm="12" xs="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Lead Service"}{" "}
                                <span
                                  style={{
                                    color: "red",
                                    marginLeft: "4px",
                                  }}
                                >
                                  *
                                </span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="leadServiceArray"
                              value={leadServiceArray}
                              onChange={(e) => {
                                setLeadServiceArray(e)
                                if (e) {
                                  api
                                    .post("/get_all_custom_field", {
                                      serviceId: e.value,
                                      status: "both",
                                    })
                                    .then((response) => {
                                      const customFieldListArray =
                                        response.data.data.length > 0
                                          ? response.data.data.map((data) => {
                                              return {
                                                _id: data._id,
                                                labelName: data.labelName,
                                                defaultValue: "",
                                                fieldName: "",
                                                helperText: data.helptext,
                                                datatype: data.datatype,
                                              }
                                            })
                                          : []

                                      console.log(
                                        customFieldListArray,
                                        "customFieldListArray"
                                      )
                                      setCustomFieldData(customFieldListArray)
                                      response.data.data
                                    })
                                }
                              }}
                              options={leadServiceOptions}
                              className={
                                !isEmpty(leadCompany) ? "" : "disabled-button"
                              }
                              placeholder="Select Service"
                              classNamePrefix="select2-selection"
                            />
                            {simpleValidator.current.message(
                              "Service",
                              leadServiceArray.value,
                              "required"
                            )}
                          </Col>
                          <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Lead Source"}{" "}
                                <span
                                  style={{
                                    color: "red",
                                    marginLeft: "4px",
                                  }}
                                >
                                  *
                                </span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="leadSource"
                              value={leadSource}
                              onChange={(e) => setLeadSource(e)}
                              options={
                                recordsMetaData.sourceOptions
                                  ? recordsMetaData.sourceOptions
                                  : []
                              }
                              placeholder="Select Source"
                              classNamePrefix="select2-selection"
                            />
                            {simpleValidator.current.message(
                              "leadSource",
                              leadSource.value,
                              "required"
                            )}
                          </Col>
                          <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Lead Sub Source"}
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="leadSubSource"
                              value={leadSubSource}
                              onChange={(e) => setLeadSubSource(e)}
                              className={
                                !isEmpty(leadSource.value)
                                  ? ""
                                  : "disabled-button"
                              }
                              options={subSourceOptions}
                              placeholder="Select Sub Source"
                              classNamePrefix="select2-selection"
                            />
                          </Col>
                          <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Sales Urge"}{" "}
                                <span
                                  style={{
                                    color: "red",
                                    marginLeft: "4px",
                                  }}
                                >
                                  *
                                </span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="salesUrge"
                              value={salesUrge}
                              onChange={(e) => setSalesUrge(e)}
                              options={[
                                { label: "Hot", value: "hot" },
                                { label: "Warm", value: "warm" },
                                { label: "Cold", value: "cold" },
                              ]}
                              placeholder="Select Sales Urge"
                              classNamePrefix="select2-selection"
                            />
                            {simpleValidator.current.message(
                              "SalesUrge",
                              salesUrge.value,
                              "required"
                            )}
                          </Col>
                          <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Client Profile"}
                              </Label>
                            </div>
                            <Select
                              name="clientProfile"
                              value={clientProfile}
                              onChange={(e) => setClientProfile(e)}
                              options={
                                leadRecordsMetaData
                                  ? leadRecordsMetaData.clientProfileOptions
                                  : []
                              }
                              placeholder="Select Client Profile"
                              classNamePrefix="select2-selection"
                            />
                          </Col>

                          <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"From Date"}
                              >
                                {"Client Profile Remarks"}
                              </Label>
                            </div>
                            <Input
                              type="text"
                              placeholder="Enter Profile Remarks"
                              name="clientProfileRemarks"
                              value={leadData.clientProfileRemarks}
                              onChange={(e) => handleLeadChange(e)}
                            />
                          </Col>
                          <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Attachment"}
                              </Label>
                            </div>
                            <Input
                              type="file"
                              name="fileAttachment"
                              // value={fileAttachment}
                              onChange={(e) => fileAttachmentChange(e)}
                              placeholder="Select Event"
                              classNamePrefix="select2-selection"
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            lg="6"
                            md="6"
                            sm="6"
                            style={{
                              paddingRight: "20px",
                            }}
                          >
                            <Row className="lead-cards">
                              <Col lg="6" md="6" sm="12" xs="12">
                                <div className="d-flex justify-content-between">
                                  <Label
                                    className="form-label"
                                    htmlFor={"From Date"}
                                  >
                                    {"First Name"}
                                    <span className="required-field">*</span>
                                  </Label>
                                </div>
                                <Input
                                  type="text"
                                  placeholder="Enter First Name"
                                  name="firstName"
                                  value={leadData.firstName}
                                  onChange={(e) => handleLeadChange(e)}
                                />
                                {simpleValidator.current.message(
                                  "FirstName",
                                  leadData.firstName,
                                  "required"
                                )}
                              </Col>
                              <Col lg="6" md="6" sm="12" xs="12">
                                <div className="d-flex justify-content-between">
                                  <Label
                                    className="form-label"
                                    htmlFor={"From Date"}
                                  >
                                    {"Last Name"}
                                  </Label>
                                </div>
                                <Input
                                  type="text"
                                  placeholder="Enter Last Name"
                                  name="lastName"
                                  value={leadData.lastName}
                                  onChange={(e) => handleLeadChange(e)}
                                />
                              </Col>
                              <Col
                                lg="6"
                                md="6"
                                sm="12"
                                xs="12"
                                className="mt-3"
                              >
                                <div className="d-flex justify-content-between">
                                  <Label
                                    className={"form-label"}
                                    htmlFor={"Branch"}
                                  >
                                    {"Country"}{" "}
                                    {/* <span className="required-field">*</span> */}
                                  </Label>
                                </div>
                                <Select
                                  type="text"
                                  name="branches"
                                  value={country}
                                  onChange={(e) => {
                                    setCountry(e)

                                    setStateData([])
                                  }}
                                  options={
                                    leadRecordsMetaData
                                      ? leadRecordsMetaData.countryOptions
                                      : []
                                  }
                                  placeholder="Select Country"
                                  classNamePrefix="select2-selection"
                                />
                                {/* {simpleValidator.current.message(
                                  "Country",
                                  country.value,
                                  "required"
                                )} */}
                              </Col>
                              <Col
                                lg="6"
                                md="6"
                                sm="12"
                                xs="12"
                                className="mt-3"
                              >
                                <div className="d-flex justify-content-between">
                                  <Label className={"form-label"}>
                                    {"State"}
                                    {/* <span className="required-field">*</span> */}
                                  </Label>
                                </div>
                                <Select
                                  name="stateData"
                                  value={stateData}
                                  onChange={(e) => {
                                    setStateData(e)

                                    setCity([])
                                  }}
                                  options={stateOptions}
                                  className={
                                    !isEmpty(country.value)
                                      ? ""
                                      : "disabled-button"
                                  }
                                  placeholder="Select State"
                                  classNamePrefix="select2-selection"
                                />
                                {/* {simpleValidator.current.message(
                                  "state",
                                  stateData.value,
                                  "required"
                                )} */}
                              </Col>
                              <Col
                                lg="6"
                                md="6"
                                sm="12"
                                xs="12"
                                className="mt-3"
                              >
                                <div className="d-flex justify-content-between">
                                  <Label className={"form-label"}>
                                    {"City"}{" "}
                                    {/* <span className="required-field">*</span> */}
                                  </Label>
                                </div>
                                <Select
                                  name="city"
                                  value={city}
                                  onChange={(e) => setCity(e)}
                                  options={cityOptions}
                                  className={
                                    !isEmpty(stateData.value)
                                      ? ""
                                      : "disabled-button"
                                  }
                                  placeholder="Select City"
                                  classNamePrefix="select2-selection"
                                />
                                {/* {simpleValidator.current.message(
                                  "city",
                                  city.value,
                                  "required"
                                )} */}
                              </Col>

                              <Col
                                lg="6"
                                md="6"
                                sm="12"
                                xs="12"
                                className="mt-3"
                              >
                                <div className="d-flex justify-content-between">
                                  <Label className={"form-label"}>
                                    PinCode
                                  </Label>
                                </div>
                                <Input
                                  type="text"
                                  name="pincode"
                                  value={leadData.pincode}
                                  onChange={(e) => handleLeadChange(e)}
                                  // disabled
                                  maxLength={6}
                                  placeholder="Enter pincode"
                                />
                              </Col>
                              <Col
                                lg="12"
                                md="12"
                                sm="12"
                                xs="12"
                                className="mt-3"
                              >
                                <div className="d-flex justify-content-between">
                                  <Label className={"form-label"}>
                                    Address
                                  </Label>
                                </div>
                                <Input
                                  type="textarea"
                                  name="address"
                                  value={leadData.address}
                                  onChange={(e) => handleLeadChange(e)}
                                  // disabled
                                  placeholder="Enter Address"
                                  className="employee-crowd-textarea"
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col
                            lg="6"
                            md="6"
                            sm="6"
                            style={{
                              paddingLeft: "15px",
                            }}
                          >
                            <Row className="lead-cards">
                              <Col lg="6" md="6" sm="12" xs="12">
                                <div className="d-flex justify-content-between">
                                  <Label
                                    className="form-label"
                                    htmlFor={"From Date"}
                                  >
                                    {"Client Location"}
                                  </Label>
                                </div>
                                <Input
                                  type="text"
                                  placeholder="Enter Client Location"
                                  name="clientLocation"
                                  value={leadData.clientLocation}
                                  onChange={(e) => handleLeadChange(e)}
                                />
                              </Col>
                              <Col lg="6" md="6" sm="12" xs="12">
                                <div className="d-flex justify-content-between">
                                  <Label
                                    className="form-label"
                                    htmlFor={"From Date"}
                                  >
                                    {"Primary No"}{" "}
                                    <span className="required-field">*</span>
                                  </Label>
                                </div>
                                <Row className="d-flex flex-row">
                                  <Col
                                    lg="1"
                                    md="1"
                                    sm="12"
                                    xs="12"
                                    className="mt-1"
                                  >
                                    <Input
                                      id="check1"
                                      type="checkbox"
                                      onClick={(e) => {
                                        if (e.target.checked) {
                                          setLeadData({
                                            ...leadData,
                                            whatsappNo: !isEmpty(
                                              leadData.primaryMobile
                                            )
                                              ? leadData.primaryMobile
                                              : "",
                                          })
                                          if (
                                            editModal &&
                                            leadData.primaryMobile ==
                                              leadData.whatsappNo
                                          ) {
                                            document.getElementById(
                                              "check2"
                                            ).checked = false
                                            document.getElementById(
                                              "check1"
                                            ).checked = true
                                          } else {
                                            document.getElementById(
                                              "check2"
                                            ).checked = false
                                          }
                                          api
                                            .post("/get_client", {
                                              status: "active",
                                              id: "",
                                              mobileNo: leadData.primaryMobile
                                                ? "+" + leadData.primaryMobile
                                                : [],
                                            })
                                            .then((res) => {
                                              // console.log(res, "response")
                                              if (
                                                res &&
                                                res.data &&
                                                res.data.data &&
                                                res.data.data.length > 0
                                              ) {
                                                setMobileData({
                                                  ...mobileData,
                                                  primaryMobileConfirm: true,
                                                  primaryMobileValue:
                                                    res.data.data &&
                                                    res.data.data[0] &&
                                                    res.data.data[0]._id,
                                                })
                                              } else {
                                                setMobileData({
                                                  ...mobileData,
                                                  primaryMobileConfirm: false,
                                                })
                                              }
                                            })
                                            .catch(() => {
                                              setMobileData({
                                                ...mobileData,
                                                primaryMobileConfirm: false,
                                              })
                                            })
                                        } else {
                                          setLeadData({
                                            ...leadData,
                                            whatsappNo: "",
                                          })
                                        }
                                      }}
                                    />{" "}
                                  </Col>
                                  <Col lg="10" md="10" sm="12" xs="12">
                                    <PhoneInput
                                      country="in"
                                      // international
                                      countryCodeEditable={false}
                                      //  defaultCountry={defaultCountry}
                                      //  maxlength={15}
                                      name="primaryMobile"
                                      placeholder="Enter Primary No"
                                      value={leadData.primaryMobile}
                                      prefix="+"
                                      inputStyle={{ maxWidth: "100%" }}
                                      onChange={(val) => {
                                        // handleLeadChange(e)
                                        setLeadData({
                                          ...leadData,
                                          primaryMobile: val,
                                        })

                                        // console.log(e, "secondaryMobile")
                                      }}
                                      copyNumbersOnly={true}
                                      international={false}
                                    />
                                  </Col>
                                  {simpleValidator.current.message(
                                    "PrimaryMobile",
                                    leadData.primaryMobile,
                                    "required"
                                  )}
                                </Row>
                              </Col>
                              <Col
                                lg="6"
                                md="6"
                                sm="12"
                                xs="12"
                                className="mt-3"
                              >
                                <div className="d-flex justify-content-between">
                                  <Label
                                    className="form-label"
                                    htmlFor={"From Date"}
                                  >
                                    {"Secondary No"}
                                  </Label>
                                </div>
                                <Row className="d-flex flex-row">
                                  <Col
                                    lg="1"
                                    md="1"
                                    sm="12"
                                    xs="12"
                                    className="mt-1"
                                  >
                                    <Input
                                      id="check2"
                                      type="checkbox"
                                      onClick={(e) => {
                                        if (e.target.checked) {
                                          setLeadData({
                                            ...leadData,
                                            whatsappNo: !isEmpty(
                                              leadData.secondaryMobile
                                            )
                                              ? leadData.secondaryMobile
                                              : "",
                                          })
                                          if (
                                            editModal &&
                                            leadData.secondaryMobile ==
                                              leadData.whatsappNo
                                          ) {
                                            document.getElementById(
                                              "check1"
                                            ).checked = false
                                            document.getElementById(
                                              "check2"
                                            ).checked = true
                                          } else {
                                            document.getElementById(
                                              "check1"
                                            ).checked = true
                                          }
                                          api
                                            .post("/get_client", {
                                              status: "active",
                                              id: "",
                                              mobileNo: leadData.secondaryMobile
                                                ? "+" + leadData.secondaryMobile
                                                : [],
                                            })
                                            .then((res) => {
                                              // console.log(res, "response")
                                              if (
                                                res &&
                                                res.data &&
                                                res.data.data &&
                                                res.data.data.length > 0
                                              ) {
                                                setMobileData({
                                                  ...mobileData,
                                                  secondaryMobileConfirm: true,
                                                  secondaryMobileValue:
                                                    res.data.data &&
                                                    res.data.data[0] &&
                                                    res.data.data[0]._id,
                                                })
                                              } else {
                                                setMobileData({
                                                  ...mobileData,
                                                  secondaryMobileConfirm: false,
                                                })
                                              }
                                            })
                                            .catch(() => {
                                              setMobileData({
                                                ...mobileData,
                                                secondaryMobileConfirm: false,
                                              })
                                            })
                                        } else {
                                          setLeadData({
                                            ...leadData,
                                            whatsappNo: "",
                                          })
                                        }
                                      }}
                                    />
                                  </Col>
                                  <Col lg="10" md="10" sm="12" xs="12">
                                    <PhoneInput
                                      country="in"
                                      // international
                                      countryCodeEditable={false}
                                      //  defaultCountry={defaultCountry}
                                      //  maxlength={15}
                                      name="secondaryMobile"
                                      placeholder="Enter Secondary No"
                                      value={leadData.secondaryMobile}
                                      prefix="+"
                                      inputStyle={{ maxWidth: "100%" }}
                                      onChange={(val) => {
                                        // handleLeadChange(e)
                                        setLeadData({
                                          ...leadData,
                                          secondaryMobile: val,
                                        })
                                        // console.log(e, "secondaryMobile")
                                      }}
                                      copyNumbersOnly={true}
                                      international={false}
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col
                                lg="6"
                                md="6"
                                sm="12"
                                xs="12"
                                className="mt-3"
                              >
                                <div className="d-flex justify-content-between">
                                  <Label
                                    className="form-label"
                                    htmlFor={"From Date"}
                                  >
                                    {"Whatsapp No"}{" "}
                                    <span className="required-field">*</span>
                                  </Label>
                                </div>
                                <div className="d-flex flex-row"> </div>
                                <PhoneInput
                                  country="in"
                                  // international
                                  countryCodeEditable={false}
                                  //  defaultCountry={defaultCountry}
                                  //  maxlength={15}
                                  name="whatsappNo"
                                  placeholder="Enter Whatsapp No"
                                  value={leadData.whatsappNo}
                                  prefix="+"
                                  inputStyle={{ maxWidth: "100%" }}
                                  onChange={(val) => {
                                    // handleLeadChange(e)
                                    setLeadData({
                                      ...leadData,
                                      whatsappNo: val,
                                    })
                                  }}
                                  copyNumbersOnly={true}
                                  international={false}
                                />
                                {simpleValidator.current.message(
                                  "WhatsappNo",
                                  leadData.whatsappNo,
                                  "required"
                                )}
                              </Col>

                              <Col
                                lg="6"
                                md="6"
                                sm="12"
                                xs="12"
                                className="mt-3"
                              >
                                <div className="d-flex justify-content-between">
                                  <Label className={"form-label"}>
                                    Email Id
                                  </Label>
                                </div>
                                <Input
                                  type="email"
                                  name="emailId"
                                  value={leadData.emailId}
                                  onChange={(e) => handleLeadChange(e)}
                                  // disabled
                                  placeholder="Enter Email"
                                />

                                <span className="required-field">
                                  {message}
                                </span>
                              </Col>
                              <Col
                                lg="6"
                                md="6"
                                sm="12"
                                xs="12"
                                className="mt-3"
                              >
                                <div className="d-flex justify-content-between">
                                  <Label className={"form-label"}>
                                    {"Priority"}{" "}
                                    <span className="required-field">*</span>
                                  </Label>
                                </div>
                                <Select
                                  name="leadPriority"
                                  value={leadPriority}
                                  onChange={(e) => setLeadPriority(e)}
                                  options={
                                    recordsMetaData.priorityOptions
                                      ? recordsMetaData.priorityOptions
                                      : []
                                  }
                                  placeholder="Select Priority"
                                  classNamePrefix="select2-selection"
                                />
                                {simpleValidator.current.message(
                                  "Priority",
                                  leadPriority.value,
                                  "required"
                                )}
                              </Col>
                              <Col
                                lg="12"
                                md="12"
                                sm="12"
                                xs="12"
                                className="mt-3"
                              >
                                <div className="d-flex justify-content-between">
                                  <Label className={"form-label"}>
                                    Remarks
                                  </Label>
                                </div>
                                <Input
                                  type="textarea"
                                  name="remarks"
                                  value={leadData.remarks}
                                  onChange={(e) => handleLeadChange(e)}
                                  // disabled
                                  placeholder="Enter Remarks"
                                  className="employee-crowd-textarea"
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            lg="6"
                            md="6"
                            sm="6"
                            style={{
                              paddingRight: "20px",
                            }}
                          >
                            <Row className="lead-cards">
                              <Col lg="12" md="12" sm="12">
                                <div className="mt-3">
                                  <h4>CROSS PROMOTIONS</h4>
                                </div>
                                <Table
                                  responsive
                                  striped
                                  style={{
                                    height: "150px",
                                    overflowY: "auto",
                                    overflowX: "hidden",
                                  }}
                                >
                                  <thead>
                                    <tr>
                                      <th>Company Name</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {!isEmpty(leadCompany.value) &&
                                    crossPromotionData.length > 0 ? (
                                      crossPromotionData.map((data, index) => {
                                        return (
                                          <tr key={index}>
                                            <td>{data.name}</td>
                                            <td className="d-flex flex-row">
                                              <div
                                                className="d-flex flex-row"
                                                style={{
                                                  fontSize: "14px",
                                                }}
                                              >
                                                <Input
                                                  type="checkbox"
                                                  id="yes"
                                                  // onClick={() =>
                                                  //   (document.getElementById(
                                                  //     // [index]["no"]
                                                  //     "no"
                                                  //   ).checked = false)
                                                  // }
                                                  name="yes"
                                                  value={data.yes}
                                                  onChange={(e) => {
                                                    handleCrossPromotionChange(
                                                      e,
                                                      index,
                                                      "yes"
                                                      // data.yes
                                                      // true
                                                    )
                                                    // document.getElementById(
                                                    //   "no"
                                                    // ).checked = false
                                                  }}
                                                />
                                                <Label check className="mx-2">
                                                  Yes
                                                </Label>
                                              </div>
                                              {/* <div
                                              className="mx-2 d-flex flex-row"
                                              style={{
                                                fontSize: "14px",
                                              }}
                                            >
                                              <Input
                                                type="switch"
                                                id="no"
                                                // onClick={() =>
                                                //   (document.getElementById(
                                                //     // [index]["yes"]
                                                //     "yes"
                                                //   ).checked = false)
                                                // }
                                                // name="no"
                                                checked={data.no}
                                                onChange={(e) => {
                                                  handleCrossPromotionChange(
                                                    e,
                                                    index,
                                                    // "no"
                                                    data.no
                                                    // false
                                                  )
                                                  // document.getElementById(
                                                  //   "yes"
                                                  // ).checked = false
                                                }}
                                              />
                                              <Label check className="mx-1 mt-1">
                                                No
                                              </Label>
                                            </div> */}
                                            </td>
                                          </tr>
                                        )
                                      })
                                    ) : (
                                      <tr key={0}>
                                        <td
                                          style={{
                                            textAlign: "center",
                                          }}
                                          colSpan={2}
                                        >
                                          No Record found
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </Table>
                              </Col>
                            </Row>
                          </Col>
                          <Col
                            lg="6"
                            md="6"
                            sm="6"
                            style={{
                              paddingLeft: "15px",
                            }}
                          >
                            <Row className="lead-cards">
                              <Col lg="12" md="12" sm="12">
                                <div
                                  className="d-flex flex-row"
                                  style={{
                                    fontSize: "18px",
                                  }}
                                >
                                  <Input
                                    type="checkbox"
                                    name="isSelfAssign"
                                    value={isSelfAssign}
                                    onChange={(e) =>
                                      setIsSelfAssign(e.target.checked)
                                    }
                                  />
                                  <Label
                                    style={{
                                      textTransform: "uppercase",
                                      marginTop: "5px",
                                      marginLeft: "6px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {" "}
                                    Self Assign
                                  </Label>
                                </div>
                              </Col>
                              <Col lg="12" md="12" sm="12">
                                <Row
                                  // className="d-flex flex-row"
                                  style={{
                                    marginTop: "15px",
                                  }}
                                >
                                  {customFieldData.length > 0 &&
                                  !isEmpty(customFieldData[0]._id)
                                    ? customFieldData.map((data, index) => {
                                        return (
                                          <Col lg="6" md="6" sm="6" key={index}>
                                            <Label
                                              style={{
                                                textTransform: "capitalize",
                                                marginTop: "5px",
                                                marginLeft: "6px",
                                                // fontWeight: "bold",
                                              }}
                                            >
                                              {data.labelName}
                                            </Label>
                                            <Input
                                              type="text"
                                              name={"defaultValue"}
                                              value={data.defaultValue}
                                              onChange={(e) =>
                                                handleCustomFieldChange(
                                                  e,
                                                  index,
                                                  "defaultValue"
                                                )
                                              }
                                              placeholder={`Enter ${data.labelName}`}
                                            />
                                          </Col>
                                        )
                                      })
                                    : ""}
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer
                        style={{
                          boxShadow: "3px 3px 12px 5px #efecec",
                        }}
                      >
                        <Button
                          type="button"
                          onClick={() => setNewLeadModal(false)}
                          className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Cancel
                        </Button>
                        {editModal == true ? (
                          <Button
                            type="submit"
                            onClick={(e) => {
                              updateNewLeadDetails(e)
                            }}
                            className="btn btn-success btn-label simple-form-applyfilter-btn"
                          >
                            <i className="bx bx-check-double label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Update"
                            )}{" "}
                          </Button>
                        ) : (
                          <Button
                            type="submit"
                            onClick={(e) => {
                              addNewLeadDetails(e)
                            }}
                            className="btn btn-success btn-label simple-form-applyfilter-btn"
                          >
                            <i className="bx bx-check-double label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Submit"
                            )}{" "}
                          </Button>
                        )}
                      </Modal.Footer>
                    </Modal>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          {clientConfirmModal && (
            <Modal size="xl" show={clientConfirmModal}>
              <Modal.Header
                style={{
                  backgroundColor: "white",
                  color: "black",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Confirm
              </Modal.Header>
              <Modal.Body>
                This lead already exists, would you like to create this lead
                under the existing lead?
              </Modal.Body>

              <Modal.Footer>
                <React.Fragment>
                  <button
                    type="button"
                    style={{ height: "46px" }}
                    className="btn btn-primary"
                    onClick={() => {
                      setClientConfirmModal(false)
                    }}
                  >
                    {"Cancel"}
                  </button>
                  <button
                    type="button"
                    style={{ height: "46px" }}
                    className="btn btn-light"
                    onClick={() => {
                      setClientConfirmModal(false)
                      setLeadData({
                        ...leadData,
                        isRequiredNewClientEntry: true,
                      })
                      // setFieldValue("clientId", "")
                      // handleSubmit()
                    }}
                  >
                    {"No"}
                  </button>
                  <button
                    type="button"
                    style={{ height: "46px" }}
                    className="btn btn-primary"
                    onClick={() => {
                      setClientConfirmModal(false)
                      setLeadData({
                        ...leadData,
                        isRequiredNewClientEntry: false,
                      })
                      addNewLeadDetails()
                      toast.success("Records Added Successfully", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 1000,
                      })
                    }}
                  >
                    {"Yes"}
                  </button>
                </React.Fragment>
              </Modal.Footer>
            </Modal>
          )}
          {leadStatusModal && (
            <Modal size="xl" show={leadStatusModal}>
              <Modal.Header
                style={{
                  backgroundColor: "#E40D8C",
                  color: "white",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Lead No: {followupData.leadNoStatus}
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                    <div className="d-flex justify-content-between">
                      <Label className={"form-label"} htmlFor={"Company"}>
                        {"Company"}{" "}
                        <span
                          style={{
                            color: "red",
                            marginLeft: "4px",
                          }}
                        >
                          *
                        </span>
                      </Label>
                    </div>

                    <Select
                      type="text"
                      name="leadStatusCompany"
                      value={leadStatusCompany}
                      onChange={(e) => setLeadStatusCompany(e)}
                      options={
                        recordsMetaData ? recordsMetaData.companyOptions : []
                      }
                      // isMulti
                      placeholder="Select Company"
                      classNamePrefix="select2-selection"
                    />
                    {simpleLeadValidator.current.message(
                      "Company",
                      leadStatusCompany,
                      "required"
                    )}
                  </Col>
                  <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                    <div className="d-flex justify-content-between">
                      <Label className={"form-label"} htmlFor={"Branch"}>
                        {"Branch"}{" "}
                        <span
                          style={{
                            color: "red",
                            marginLeft: "4px",
                          }}
                        >
                          *
                        </span>
                      </Label>
                    </div>
                    <Select
                      type="text"
                      name="leadStatusBranch"
                      value={leadStatusBranch}
                      onChange={(e) => setLeadStatusBranch(e)}
                      options={leadStatusBranchOptions}
                      placeholder="Select Branch"
                      classNamePrefix="select2-selection"
                    />
                    {simpleLeadValidator.current.message(
                      "Branch",
                      leadStatusBranch.value,
                      "required"
                    )}
                  </Col>

                  <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                    <div className="d-flex justify-content-between">
                      <Label className="form-label" htmlFor={"From Date"}>
                        {"Employee"}{" "}
                        <span
                          style={{
                            color: "red",
                            marginLeft: "4px",
                          }}
                        >
                          * (Auto Fill)
                        </span>
                      </Label>
                    </div>
                    <ReactSearchAutocomplete
                      name="leadStatusEmployee"
                      key={resetManager}
                      items={employeeOptions}
                      value={leadStatusEmployee ? leadStatusEmployee : ""}
                      type="autoComplete"
                      resultStringKeyName="label"
                      showIcon={false}
                      onSelect={(e) => setLeadStatusEmployee(e)}
                      onChange={(e) => setLeadStatusEmployee(e.target.value)}
                      placeholder="Enter Employee Code"
                      fuseOptions={fuseOptions} // Search on both fields
                      styling={{
                        height: "34px",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                        backgroundColor: "white",
                        boxShadow: "none",
                        hoverBackgroundColor: "#E40D8C",
                        color: "black",
                        fontSize: "12px",
                        fontFamily: "Courier",
                        iconColor: "green",
                        clearIconMargin: "3px 8px 0 0",
                        zIndex: 10,
                      }}
                    />

                    {simpleLeadValidator.current.message(
                      "Employee",
                      leadStatusEmployee.value,
                      "required"
                    )}
                  </Col>
                  <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                    <div className="d-flex justify-content-between">
                      <Label className={"form-label"}>
                        {"Priority"}{" "}
                        <span
                          style={{
                            color: "red",
                            marginLeft: "4px",
                          }}
                        >
                          *
                        </span>
                      </Label>
                    </div>
                    <Select
                      name="leadStatusPriority"
                      value={leadStatusPriority}
                      onChange={(e) => setLeadStatusPriority(e)}
                      options={
                        recordsMetaData.priorityOptions
                          ? recordsMetaData.priorityOptions
                          : []
                      }
                      placeholder="Select Priority"
                      classNamePrefix="select2-selection"
                    />
                    {simpleLeadValidator.current.message(
                      "priority",
                      leadStatusPriority.value,
                      "required"
                    )}
                  </Col>
                </Row>
              </Modal.Body>

              <Modal.Footer>
                <Col lg="12" md="12" sm="12" xs="12" className="mt-4">
                  <div className="filter-buttons" style={{ float: "right" }}>
                    <Button
                      type="button"
                      onClick={() => {
                        setLeadStatusModal(false)
                        setLeadStatusCompany([])
                        setLeadStatusBranch([])
                        setLeadStatusEmployee([])
                        setLeadStatusPriority([])
                      }}
                      className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                    >
                      <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      onClick={(e) => {
                        addLeadAssign(e)
                      }}
                      className="btn btn-success btn-label simple-form-applyfilter-btn"
                    >
                      <i className="bx bx-filter-alt label-icon"></i>
                      {/* {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : ( */}
                      {"Submit"}
                      {/* )}{" "} */}
                    </Button>
                  </div>
                </Col>
              </Modal.Footer>
            </Modal>
          )}
          {/* Delete Lead */}
          {deleteLeadModal && (
            <Modal
              show={deleteLeadModal}
              size="md"
              style={{ backgroundColor: "#504e4ec9", opacity: 0.98 }}
            >
              <Modal.Header
                style={{
                  backgroundColor: "#E40D8C",
                  color: "white",
                  minHeight: "65px",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                <div className="d-flex flex-row">
                  <span>Delete Lead</span>
                </div>
              </Modal.Header>
              <Modal.Body>
                Are you sure, you want to Delete the Lead Details?
              </Modal.Body>
              <Modal.Footer>
                <div>
                  <Button
                    className="btn btn-danger buttons"
                    type="submit"
                    onClick={() => {
                      setDeleteLeadModal(false)
                    }}
                    style={{ fontSize: "10px", marginLeft: "20px" }}
                  >
                    {" "}
                    Cancel
                  </Button>
                  <Button
                    type="button"
                    onClick={() => {
                      deleteNewLead()
                    }}
                    style={{ fontSize: "10px", marginLeft: "20px" }}
                    className="btn btn-success success"
                  >
                    {" "}
                    Delete{" "}
                  </Button>
                </div>
              </Modal.Footer>
            </Modal>
          )}
        </Container>
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </React.Fragment>
  )
}

NewManageLead.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
  baseProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  csvProps: PropTypes.any,
  pageClick: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NewManageLead)
)
